import { ShoesState } from 'src/types'
import { generateLiningsGradient } from 'src/util/canvas'
import { darkenColor } from 'src/util/color'
import { generateMesh } from './parts/meshMatrial'
import { getUpperMaterial } from 'src/features/atoms/shoes/logic'
import { canvasResetter } from 'src/util/canvas'

// // 歯a
// ctx.strokeStyle = 'red'
// ctx.beginPath()
// ctx.moveTo(378, 262) // 左下
// // ctx.quadraticCurveTo()
// ctx.fill()
// ctx.stroke()
// ctx.closePath()
// ctx.strokeStyle = '#383838'

const tongueFrontRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  if (state.tongue.value === 'foldingTongue') return // 折りベロ
  ctx.fillStyle = state.tongueLinings.color
  ctx.strokeStyle = '#383838'
  ctx.beginPath()
  ctx.moveTo(258 + x, 123 + y)
  ctx.quadraticCurveTo(279 + x, 108 + y, 304 + x, 111 + y)
  ctx.quadraticCurveTo(258 + x, 123 + y, 258 + x, 123 + y)

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#383838'
  const coordinates = { x0: 0, y0: 250, x1: 5, y1: 350 }
  const gradient = generateLiningsGradient(ctx, state.tongueFront.color, coordinates)
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(260 + x, 124 + y) // 頂点
  ctx.quadraticCurveTo(273 + x, 114 + y, 287 + x, 115 + y) // 頂点右
  ctx.quadraticCurveTo(295 + x, 114 + y, 299 + x, 111 + y)
  ctx.quadraticCurveTo(312 + x, 111 + y, 316 + x, 121 + y) // 右上＿下
  ctx.quadraticCurveTo(326 + x, 142 + y, 326 + x, 167 + y) // ベロ右下
  ctx.quadraticCurveTo(412 + x, 433 + y, 412 + x, 433 + y) // 右下（つま先補強）
  ctx.quadraticCurveTo(316 + x, 466 + y, 316 + x, 466 + y) // 左下（つま先補強）
  ctx.quadraticCurveTo(221 + x, 197 + y, 221 + x, 197 + y) // ベロ左下
  ctx.quadraticCurveTo(215 + x, 190 + y, 213 + x, 178 + y)
  ctx.quadraticCurveTo(211 + x, 163 + y, 219 + x, 155 + y) // 左上＿下
  ctx.quadraticCurveTo(222 + x, 146 + y, 241 + x, 135 + y) // 頂点左
  ctx.quadraticCurveTo(260 + x, 124 + y, 260 + x, 124 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.moveTo(252 + x, 233 + y) // ベロ右下
  ctx.quadraticCurveTo(290 + x, 200 + y, 326 + x, 204 + y)
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(259 + x, 232 + y) // 右下
  ctx.quadraticCurveTo(294 + x, 204 + y, 325 + x, 207 + y)
  ctx.moveTo(259 + x, 242 + y) // 右下
  ctx.quadraticCurveTo(294 + x, 214 + y, 325 + x, 217 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
} // ベロ表

const tongueFrontLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  ctx.fillStyle = state.tongueLinings.color
  ctx.strokeStyle = '#383838'
  ctx.beginPath()
  ctx.moveTo(375 + x, 84 + y)
  ctx.quadraticCurveTo(396 + x, 56 + y, 396 + x, 56 + y)
  ctx.quadraticCurveTo(399 + x, 43 + y, 409 + x, 43 + y)
  ctx.quadraticCurveTo(382 + x, 84 + y, 375 + x, 84 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  const coordinates = { x0: 0, y0: 300, x1: 10, y1: 140 }
  const gradient = generateLiningsGradient(ctx, state.tongueFront.color, coordinates)
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(397 + x, 61 + y) // 頂点
  ctx.quadraticCurveTo(407 + x, 46 + y, 409 + x, 43 + y) // 右上
  ctx.quadraticCurveTo(444 + x, 68 + y, 473 + x, 110 + y) // 右下
  ctx.quadraticCurveTo(446 + x, 136 + y, 446 + x, 136 + y) // 左下
  ctx.quadraticCurveTo(376 + x, 148 + y, 376 + x, 148 + y) // 左下_上
  ctx.quadraticCurveTo(353 + x, 138 + y, 353 + x, 138 + y) // 左上＿下
  ctx.quadraticCurveTo(339 + x, 111 + y, 356 + x, 103 + y)
  ctx.quadraticCurveTo(397 + x, 61 + y, 397 + x, 61 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(473 + x, 110 + y)
  ctx.quadraticCurveTo(572 + x, 195 + y, 648 + x, 232 + y)
  ctx.quadraticCurveTo(622 + x, 274 + y, 622 + x, 274 + y)
  ctx.quadraticCurveTo(542 + x, 249 + y, 446 + x, 136 + y)
  ctx.quadraticCurveTo(473 + x, 110 + y, 473 + x, 110 + y)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(455 + x, 133 + y) // 右下
  ctx.quadraticCurveTo(473 + x, 114 + y, 473 + x, 114 + y)
  ctx.moveTo(462 + x, 139 + y) // 右下
  ctx.quadraticCurveTo(480 + x, 121 + y, 480 + x, 120 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
} // ベロ表

const laceHole = (ctx: CanvasRenderingContext2D, state: ShoesState, x: number, y: number): void => {
  ctx.strokeStyle = '#fff'
  ctx.fillStyle = '#383838'
  ctx.beginPath()
  ctx.arc(x, y, 4, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// 紐-左下右上
const leftDownRightUp = (ctx: CanvasRenderingContext2D, x = 0, y = 0): void => {
  // 一番下
  ctx.beginPath()
  ctx.moveTo(325 + x, 433 + y) // 左下
  ctx.quadraticCurveTo(322 + x, 421 + y, 322 + x, 423 + y) // 左上
  ctx.quadraticCurveTo(399 + x, 370 + y, 399 + x, 370 + y) // 右上
  ctx.quadraticCurveTo(411 + x, 371 + y, 404 + x, 379 + y) // 右下
  ctx.quadraticCurveTo(325 + x, 433 + y, 325 + x, 433 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// 紐-右下左上
const rightDownLeftUp = (ctx: CanvasRenderingContext2D, x = 0, y = 0): void => {
  // 一番下
  ctx.beginPath()
  ctx.moveTo(295 + x, 418 + y) // 左下
  ctx.quadraticCurveTo(288 + x, 415 + y, 291 + x, 408 + y) // 左上
  ctx.quadraticCurveTo(396 + x, 401 + y, 396 + x, 401 + y) // 右上
  ctx.quadraticCurveTo(398 + x, 411 + y, 398 + x, 411 + y) // 右下
  ctx.quadraticCurveTo(295 + x, 418 + y, 295 + x, 418 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const magicBeltBase = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.magicBeltBase.color
  // 下地
  ctx.beginPath()
  ctx.moveTo(280 + x, 399 + y) // 左下
  ctx.quadraticCurveTo(274 + x, 373 + y, 274 + x, 373 + y) // 左上
  ctx.quadraticCurveTo(377 + x, 345 + y, 377 + x, 345 + y) // 右上
  ctx.quadraticCurveTo(386 + x, 370 + y, 386 + x, 370 + y) // 右下
  ctx.quadraticCurveTo(280 + x, 399 + y, 280 + x, 399 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
const turnAroundMetalFittings = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  ctx.strokeStyle = '#ccc'
  ctx.fillStyle = '#ccc'
  ctx.beginPath()
  ctx.moveTo(370 + x, 345 + y) // 左下_左
  ctx.quadraticCurveTo(366 + x, 335 + y, 377 + x, 336 + y) // 右上_左
  ctx.quadraticCurveTo(380 + x, 339 + y, 378 + x, 339 + y) // 右上_右
  ctx.quadraticCurveTo(369 + x, 337 + y, 374 + x, 345 + y) // 左下_右
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(381 + x, 374 + y)
  ctx.quadraticCurveTo(388 + x, 385 + y, 393 + x, 372 + y)
  ctx.quadraticCurveTo(390 + x, 372 + y, 390 + x, 372 + y)
  ctx.quadraticCurveTo(388 + x, 379 + y, 384 + x, 372 + y)
  ctx.quadraticCurveTo(381 + x, 374 + y, 381 + x, 374 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
const magicBeltTurnAround = (ctx: CanvasRenderingContext2D, beltColor: string, state: ShoesState, x = 0, y = 0): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = beltColor
  ctx.beginPath()
  ctx.moveTo(279 + x, 384 + y) // 左上_下
  ctx.quadraticCurveTo(262 + x, 375 + y, 280 + x, 368 + y) // 左上_上
  ctx.quadraticCurveTo(380 + x, 343 + y, 380 + x, 341 + y) // 右上
  ctx.quadraticCurveTo(388 + x, 352 + y, 391 + x, 371 + y) // 右下
  ctx.quadraticCurveTo(297 + x, 393 + y, 297 + x, 393 + y)
  ctx.quadraticCurveTo(294 + x, 397 + y, 279 + x, 384 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.3
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.beginPath()
  ctx.moveTo(294 + x, 388 + y) // 左下
  ctx.quadraticCurveTo(279 + x, 374 + y, 279 + x, 374 + y)
  ctx.quadraticCurveTo(381 + x, 347 + y, 381 + x, 347 + y)
  ctx.moveTo(294 + x, 389 + y)
  ctx.quadraticCurveTo(384 + x, 367 + y, 384 + x, 367 + y)

  ctx.moveTo(313 + x, 367 + y)
  ctx.quadraticCurveTo(326 + x, 379 + y, 326 + x, 379 + y)
  ctx.moveTo(329 + x, 364 + y)
  ctx.quadraticCurveTo(338 + x, 374 + y, 338 + x, 374 + y)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}
const magicBeltTurnAroundReverse = (ctx: CanvasRenderingContext2D, beltColor: string, state: ShoesState, x = 0, y = 0) => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = beltColor
  ctx.beginPath()
  ctx.moveTo(282 + x, 351 + y) // 左下
  ctx.quadraticCurveTo(273 + x, 337 + y, 274 + x, 323 + y) // 左上
  ctx.quadraticCurveTo(327 + x, 307 + y, 378 + x, 296 + y) // 右上
  ctx.quadraticCurveTo(381 + x, 310 + y, 376 + x, 323 + y) // 右下
  ctx.quadraticCurveTo(282 + x, 351 + y, 282 + x, 351 + y) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.3
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.beginPath()
  ctx.moveTo(284 + x, 345 + y) // 左下
  ctx.quadraticCurveTo(373 + x, 319 + y, 372 + x, 319 + y) // 右下
  ctx.quadraticCurveTo(375 + x, 301 + y, 375 + x, 301 + y) // 右上
  ctx.quadraticCurveTo(332 + x, 308 + y, 277 + x, 328 + y)

  ctx.moveTo(334 + x, 314 + y)
  ctx.quadraticCurveTo(331 + x, 333 + y, 331 + x, 333 + y)
  ctx.moveTo(346 + x, 309 + y)
  ctx.quadraticCurveTo(344 + x, 327 + y, 344 + x, 327 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}
// 紐・ベルト補強
const vampStrapReinforcementRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  switch (state.openingPattern.value) {
    case 'quarterCut': {
      // 右のvampStrapReinforcementの裏地
      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.tongueLinings.color
      ctx.beginPath()
      ctx.moveTo(329, 166)
      ctx.quadraticCurveTo(320, 189, 341, 243) // 右下_右下
      ctx.quadraticCurveTo(333, 245, 333, 245) // 右下_左下
      ctx.quadraticCurveTo(318, 187, 318, 187)
      ctx.quadraticCurveTo(316, 174, 321, 167)
      ctx.quadraticCurveTo(329, 166, 329, 166)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // 左のvampStrapReinforcementの裏地
      ctx.fillStyle = state.tongueLinings.color
      ctx.beginPath()
      ctx.moveTo(226, 194) // 右上
      ctx.quadraticCurveTo(255, 198, 269, 267) // 左下
      ctx.quadraticCurveTo(278, 269, 276, 269) // 右下
      ctx.quadraticCurveTo(257, 180, 226, 194)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      ctx.strokeStyle = '#fff'
      ctx.fillStyle = state.vampStrapReinforcement.color

      // 外側の補強パーツ
      ctx.beginPath()
      ctx.moveTo(222, 196) // 頂点
      ctx.quadraticCurveTo(236, 188, 250, 212)
      ctx.quadraticCurveTo(258, 221, 260, 231)
      ctx.quadraticCurveTo(259, 242, 270, 267)
      ctx.quadraticCurveTo(317, 422, 317, 422) // 右下
      ctx.quadraticCurveTo(281, 432, 281, 432) // 左下
      ctx.quadraticCurveTo(274, 395, 269, 381)
      ctx.quadraticCurveTo(266, 355, 262, 347)
      ctx.quadraticCurveTo(249, 304, 233, 271)
      ctx.quadraticCurveTo(220, 211, 220, 211)
      ctx.quadraticCurveTo(216, 200, 222, 196)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // stitch
      ctx.lineWidth = 1.3
      ctx.strokeStyle = state.stitch.color
      ctx.setLineDash([3, 3])
      ctx.beginPath()
      ctx.moveTo(283, 430) // 左下
      ctx.quadraticCurveTo(275, 367, 253, 309)
      ctx.quadraticCurveTo(234, 274, 223, 208) // 左上
      ctx.quadraticCurveTo(223, 196, 234, 202)
      ctx.quadraticCurveTo(248, 214, 255, 231)
      ctx.quadraticCurveTo(258, 258, 267, 273)
      ctx.quadraticCurveTo(310, 416, 310, 416)

      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      break
    }
    default: {
      // 右のvampStrapReinforcementの裏地
      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.tongueLinings.color
      ctx.beginPath()
      ctx.moveTo(337, 186)
      ctx.quadraticCurveTo(328, 209, 349, 263) // 右下_右下
      ctx.quadraticCurveTo(341, 265, 341, 265) // 右下_左下
      ctx.quadraticCurveTo(326, 207, 326, 207)
      ctx.quadraticCurveTo(324, 194, 329, 187)
      ctx.quadraticCurveTo(337, 186, 337, 186)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // 左のvampStrapReinforcementの裏地
      ctx.fillStyle = state.tongueLinings.color
      ctx.beginPath()
      ctx.moveTo(234, 214) // 右上
      ctx.quadraticCurveTo(263, 218, 277, 287) // 左下
      ctx.quadraticCurveTo(286, 289, 284, 289) // 右下
      ctx.quadraticCurveTo(265, 200, 234, 214)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      ctx.strokeStyle = '#fff'
      ctx.fillStyle = state.vampStrapReinforcement.color

      // 外側の補強パーツ
      ctx.beginPath()
      ctx.moveTo(230, 216) // 頂点
      ctx.quadraticCurveTo(244, 208, 258, 232)
      ctx.quadraticCurveTo(262, 241, 265, 251)
      // ctx.quadraticCurveTo(259, 242, 270, 267)
      ctx.quadraticCurveTo(317, 422, 317, 422) // 右下
      ctx.quadraticCurveTo(281, 432, 281, 432) // 左下
      ctx.quadraticCurveTo(274, 395, 269, 381)
      ctx.quadraticCurveTo(266, 355, 262, 347)
      ctx.quadraticCurveTo(249, 304, 233, 271)
      ctx.quadraticCurveTo(224, 220, 230, 216)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // stitch
      ctx.lineWidth = 1.3
      ctx.strokeStyle = state.stitch.color
      ctx.setLineDash([3, 3])
      ctx.beginPath()
      ctx.moveTo(283, 430) // 左下
      ctx.quadraticCurveTo(275, 367, 253, 309)
      ctx.quadraticCurveTo(234, 274, 231, 229) // 左上
      ctx.quadraticCurveTo(230, 217, 236, 221)
      ctx.quadraticCurveTo(239, 212, 253, 231)
      ctx.quadraticCurveTo(264, 258, 267, 273)
      ctx.quadraticCurveTo(310, 416, 310, 416)

      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      break
    }
  }
  if (state.vampStrapType.value === 'laceType') {
    // 右足_外側_紐穴
    if (state.openingPattern.value === 'quarterCut') {
      laceHole(ctx, state, 240, 230)
    }
    laceHole(ctx, state, 251, 271)
    laceHole(ctx, state, 263, 308)
    laceHole(ctx, state, 277, 345)
    laceHole(ctx, state, 287, 379)
    laceHole(ctx, state, 292, 414)
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.vampStrap.color
    rightDownLeftUp(ctx, -40, -140)
    rightDownLeftUp(ctx, -28, -104)
    rightDownLeftUp(ctx, -13, -66)
    rightDownLeftUp(ctx, -5, -32)
    rightDownLeftUp(ctx)
  }

  switch (state.openingPattern.value) {
    case 'quarterCut': {
      // 内側の補強パーツ
      ctx.strokeStyle = '#fff'
      ctx.fillStyle = state.vampStrapReinforcement.color
      ctx.beginPath()
      ctx.moveTo(326, 190) // 左上
      ctx.quadraticCurveTo(338, 229, 348, 276)
      ctx.quadraticCurveTo(364, 313, 399, 402) // 左下
      ctx.quadraticCurveTo(431, 401, 431, 401) // 右下
      ctx.quadraticCurveTo(413, 360, 413, 360)
      ctx.quadraticCurveTo(411, 337, 390, 306)
      ctx.quadraticCurveTo(372, 269, 357, 219) // 右上
      ctx.quadraticCurveTo(356, 213, 352, 211)
      ctx.quadraticCurveTo(339, 172, 336, 170)
      ctx.quadraticCurveTo(327, 155, 326, 190)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // stitch
      ctx.lineWidth = 1.3
      ctx.strokeStyle = state.stitch.color
      ctx.setLineDash([3, 3])
      ctx.beginPath()

      ctx.moveTo(397, 388) // 左下
      ctx.quadraticCurveTo(352, 275, 352, 275)
      ctx.quadraticCurveTo(329, 190, 329, 190)
      ctx.quadraticCurveTo(330, 158, 336, 175) // 右上
      ctx.quadraticCurveTo(348, 219, 353, 218)
      ctx.quadraticCurveTo(376, 287, 398, 326)
      ctx.quadraticCurveTo(419, 386, 421, 386)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      break
    }
    default: {
      // 内側の補強パーツ
      ctx.strokeStyle = '#fff'
      ctx.fillStyle = state.vampStrapReinforcement.color
      ctx.beginPath()
      ctx.moveTo(334, 210) // 左上
      ctx.quadraticCurveTo(346, 249, 356, 296)
      ctx.quadraticCurveTo(364, 313, 399, 402) // 左下
      ctx.quadraticCurveTo(431, 401, 431, 401) // 右下
      ctx.quadraticCurveTo(413, 360, 413, 360)
      ctx.quadraticCurveTo(411, 337, 390, 306)
      ctx.quadraticCurveTo(372, 269, 357, 219) // 右上
      ctx.quadraticCurveTo(347, 192, 344, 190)
      ctx.quadraticCurveTo(327, 175, 334, 210)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // stitch
      ctx.lineWidth = 1.3
      ctx.strokeStyle = state.stitch.color
      ctx.setLineDash([3, 3])
      ctx.beginPath()

      ctx.moveTo(397, 388) // 左下
      ctx.quadraticCurveTo(354, 275, 354, 275)
      ctx.quadraticCurveTo(340, 210, 337, 210)
      ctx.quadraticCurveTo(332, 180, 344, 195) // 右上
      ctx.quadraticCurveTo(376, 287, 398, 326)
      ctx.quadraticCurveTo(419, 386, 421, 386)
      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      break
    }
  }

  if (state.vampStrapType.value === 'laceType') {
    // 右足_内側_紐穴
    if (state.openingPattern.value === 'quarterCut') {
      laceHole(ctx, state, 340, 200)
    }
    laceHole(ctx, state, 354, 243)
    laceHole(ctx, state, 365, 275)
    laceHole(ctx, state, 378, 310)
    laceHole(ctx, state, 391, 342)
    laceHole(ctx, state, 403, 373)

    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.vampStrap.color
    leftDownRightUp(ctx, -45, -131)
    leftDownRightUp(ctx, -36, -98)
    leftDownRightUp(ctx, -24, -64)
    leftDownRightUp(ctx, -14, -32)
    leftDownRightUp(ctx, -2)
  }

  if (state.vampStrapType.value === 'beltTypeSameDirection') {
    // 一番上
    magicBeltBase(ctx, state, -30, -100)
    turnAroundMetalFittings(ctx, state, -30, -100)
    const belt1Color = state.vampStrapBelt1.color
    magicBeltTurnAround(ctx, belt1Color, state, -30, -100)

    // 中間
    magicBeltBase(ctx, state, -15, -50)
    turnAroundMetalFittings(ctx, state, -15, -50)
    const belt2Color = state.vampStrapBelt2.color
    magicBeltTurnAround(ctx, belt2Color, state, -15, -50)

    // 一番下
    magicBeltBase(ctx, state)
    turnAroundMetalFittings(ctx, state)
    const belt3Color = state.vampStrapBelt3.color
    magicBeltTurnAround(ctx, belt3Color, state)
  }
  if (state.vampStrapType.value === 'beltTypeReverseDirection') {
    // 一番上
    magicBeltBase(ctx, state, -30, -100)
    turnAroundMetalFittings(ctx, state, -30, -100)
    const belt1Color = state.vampStrapBelt1.color
    magicBeltTurnAround(ctx, belt1Color, state, -30, -100)

    // 中間
    magicBeltBase(ctx, state, 3, -55)
    turnAroundMetalFittings(ctx, state, -95, -25)
    const belt2Color = state.vampStrapBelt2.color
    magicBeltTurnAroundReverse(ctx, belt2Color, state, 4, -5)

    // 一番下
    magicBeltBase(ctx, state)
    turnAroundMetalFittings(ctx, state)
    const belt3Color = state.vampStrapBelt3.color
    magicBeltTurnAround(ctx, belt3Color, state)
  }
}
// 左足の紐
const laceOfLeftFoot1 = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.vampStrap.color
  ctx.beginPath()
  ctx.moveTo(601 + x, 255 + y) // 左下
  ctx.quadraticCurveTo(593 + x, 250 + y, 593 + x, 250 + y) // 左上
  ctx.quadraticCurveTo(600 + x, 225 + y, 604 + x, 191 + y) // 右上
  ctx.quadraticCurveTo(610 + x, 193 + y, 612 + x, 200 + y) // 右下
  ctx.quadraticCurveTo(609 + x, 231 + y, 601 + x, 254 + y) // 左下
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
const laceOfLeftFoot2 = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.vampStrap.color
  ctx.beginPath()
  ctx.moveTo(572 + x, 257 + y) // 左下
  ctx.quadraticCurveTo(560 + x, 260 + y, 561 + x, 250 + y) // 左上
  ctx.quadraticCurveTo(585 + x, 224 + y, 613 + x, 214 + y) // 右上
  ctx.quadraticCurveTo(621 + x, 218 + y, 619 + x, 221 + y) // 右下
  ctx.quadraticCurveTo(588 + x, 237 + y, 572 + x, 257 + y) // 左下
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
// 紐・ベルト補強
const vampStrapReinforcementLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#fff'
  ctx.fillStyle = state.vampStrapReinforcement.color

  // 外側の補強パーツ-表地
  ctx.beginPath()
  ctx.moveTo(536, 151) // 左上
  ctx.quadraticCurveTo(589, 195, 615, 209) // 右下
  ctx.quadraticCurveTo(617, 204, 617, 204)
  ctx.quadraticCurveTo(536, 151, 536, 151)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  switch (state.openingPattern.value) {
    case 'quarterCut': {
      if (['laceType', 'unselected'].includes(state.vampStrapType.value)) {
        ctx.beginPath()
        ctx.moveTo(400, 137) // 左上
        ctx.quadraticCurveTo(395, 132, 405, 120)
        ctx.quadraticCurveTo(433, 101, 456, 128) // 右上
        ctx.quadraticCurveTo(518, 204, 593, 253) // 右下
        ctx.quadraticCurveTo(578, 287, 578, 283) // 左下
        ctx.quadraticCurveTo(448, 211, 400, 137)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()

        // stitch
        ctx.lineWidth = 1.2
        ctx.strokeStyle = state.stitch.color
        ctx.setLineDash([3, 3])
        ctx.beginPath()
        ctx.moveTo(569, 272) // 左下
        ctx.quadraticCurveTo(465, 215, 403, 137) // 左上
        ctx.quadraticCurveTo(400, 121, 430, 117) // 右上
        ctx.quadraticCurveTo(444, 118, 456, 136)
        ctx.quadraticCurveTo(506, 195, 582, 252)
        ctx.stroke()
        ctx.setLineDash([])
        ctx.closePath()
      }
      if (state.vampStrapType.value === 'beltTypeSameDirection') {
        ctx.beginPath()
        ctx.moveTo(400, 137) // 左上
        ctx.quadraticCurveTo(395, 132, 405, 120)
        ctx.quadraticCurveTo(433, 101, 456, 128) // 右上
        ctx.quadraticCurveTo(470, 151, 470, 151) // ベルト1段目への接続
        ctx.quadraticCurveTo(487, 173, 496, 168)
        ctx.quadraticCurveTo(514, 182, 514, 182)
        ctx.quadraticCurveTo(513, 185, 515, 190)
        ctx.quadraticCurveTo(518, 197, 523, 194) // ベルト2段目への接続
        ctx.quadraticCurveTo(544, 210, 544, 210)
        ctx.quadraticCurveTo(538, 214, 545, 217)
        ctx.quadraticCurveTo(548, 225, 557, 220) // ベルト3段目への接続
        ctx.quadraticCurveTo(576, 234, 576, 234)
        // ctx.quadraticCurveTo()
        ctx.quadraticCurveTo(567, 237, 593, 253) // 右下
        ctx.quadraticCurveTo(578, 287, 578, 283) // 左下
        ctx.quadraticCurveTo(448, 211, 400, 137)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()

        // stitch
        ctx.lineWidth = 1.2
        ctx.strokeStyle = state.stitch.color
        ctx.setLineDash([3, 3])
        ctx.beginPath()
        ctx.moveTo(569, 272) // 左下
        ctx.quadraticCurveTo(465, 215, 403, 137) // 左上
        ctx.quadraticCurveTo(400, 121, 430, 117) // 右上
        ctx.quadraticCurveTo(440, 118, 456, 136)
        ctx.quadraticCurveTo(490, 190, 582, 252)
        ctx.stroke()
        ctx.setLineDash([])
        ctx.closePath()
      }
      if (state.vampStrapType.value === 'beltTypeReverseDirection') {
        ctx.beginPath()
        ctx.moveTo(400, 137) // 左上
        ctx.quadraticCurveTo(395, 132, 405, 120)
        ctx.quadraticCurveTo(433, 101, 456, 128) // 右上
        ctx.quadraticCurveTo(470, 151, 470, 151) // ベルト1段目への接続
        ctx.quadraticCurveTo(487, 173, 496, 168)
        ctx.quadraticCurveTo(514, 182, 514, 182)
        ctx.quadraticCurveTo(513, 185, 515, 190)
        ctx.quadraticCurveTo(548, 225, 557, 220) // ベルト3段目への接続
        ctx.quadraticCurveTo(576, 234, 576, 234)
        // ctx.quadraticCurveTo()
        ctx.quadraticCurveTo(569, 239, 593, 253) // 右下
        ctx.quadraticCurveTo(578, 287, 578, 283) // 左下
        ctx.quadraticCurveTo(448, 211, 400, 137)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()

        // stitch
        ctx.lineWidth = 1.2
        ctx.strokeStyle = state.stitch.color
        ctx.setLineDash([3, 3])
        ctx.beginPath()
        ctx.moveTo(569, 272) // 左下
        ctx.quadraticCurveTo(465, 215, 403, 137) // 左上
        ctx.quadraticCurveTo(400, 121, 430, 117) // 右上
        ctx.quadraticCurveTo(440, 118, 456, 136)
        ctx.quadraticCurveTo(490, 190, 582, 252)
        ctx.stroke()
        ctx.setLineDash([])
        ctx.closePath()
      }
      break
    }
    default: {
      if (state.vampStrapType.value === 'beltTypeSameDirection') {
        ctx.beginPath()
        ctx.moveTo(417, 163) // 左上
        ctx.quadraticCurveTo(400, 135, 449, 143) // 右上
        ctx.quadraticCurveTo(478, 168, 478, 168) // ベルト1段目への接続
        ctx.quadraticCurveTo(487, 173, 496, 168)
        ctx.quadraticCurveTo(514, 182, 514, 182)
        ctx.quadraticCurveTo(513, 185, 515, 190)
        ctx.quadraticCurveTo(518, 197, 523, 194) // ベルト2段目への接続
        ctx.quadraticCurveTo(544, 210, 544, 210)
        ctx.quadraticCurveTo(538, 214, 545, 217)
        ctx.quadraticCurveTo(548, 225, 557, 220) // ベルト3段目への接続
        ctx.quadraticCurveTo(576, 234, 576, 234)
        // ctx.quadraticCurveTo()
        ctx.quadraticCurveTo(572, 239, 593, 253) // 右下
        ctx.quadraticCurveTo(578, 287, 578, 283) // 左下
        ctx.quadraticCurveTo(452, 211, 417, 163)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        // stitch
        ctx.lineWidth = 1.2
        ctx.strokeStyle = state.stitch.color
        ctx.setLineDash([3, 3])
        ctx.beginPath()
        ctx.moveTo(569, 272) // 左下
        ctx.quadraticCurveTo(465, 215, 418, 155) // 左上
        ctx.quadraticCurveTo(417, 143, 448, 148) // 右上
        ctx.quadraticCurveTo(500, 200, 582, 252)
        ctx.stroke()
        ctx.setLineDash([])
        ctx.closePath()
        ctx.strokeStyle = '#fff'
      }
      if (state.vampStrapType.value === 'beltTypeReverseDirection') {
        ctx.beginPath()
        ctx.moveTo(417, 163) // 左上
        ctx.quadraticCurveTo(400, 135, 449, 143) // 右上
        ctx.quadraticCurveTo(478, 168, 478, 168) // ベルト1段目への接続
        ctx.quadraticCurveTo(487, 173, 496, 168)
        ctx.quadraticCurveTo(514, 182, 514, 182)
        ctx.quadraticCurveTo(513, 185, 515, 190)
        ctx.quadraticCurveTo(548, 225, 557, 220) // ベルト3段目への接続
        ctx.quadraticCurveTo(576, 234, 576, 234)
        // ctx.quadraticCurveTo()
        ctx.quadraticCurveTo(572, 239, 593, 253) // 右下
        ctx.quadraticCurveTo(578, 287, 578, 283) // 左下
        ctx.quadraticCurveTo(452, 211, 417, 163)
        ctx.stroke()
        ctx.fill()
        ctx.closePath()
        // stitch
        ctx.lineWidth = 1.2
        ctx.strokeStyle = state.stitch.color
        ctx.setLineDash([3, 3])
        ctx.beginPath()
        ctx.moveTo(569, 272) // 左下
        ctx.quadraticCurveTo(465, 215, 418, 155) // 左上
        ctx.quadraticCurveTo(417, 143, 448, 148) // 右上
        ctx.quadraticCurveTo(500, 200, 582, 252)
        ctx.stroke()
        ctx.setLineDash([])
        ctx.closePath()
        ctx.strokeStyle = '#fff'
      }
      ctx.beginPath()
      ctx.moveTo(417, 163) // 左上
      ctx.quadraticCurveTo(400, 135, 449, 143) // 右上
      ctx.quadraticCurveTo(572, 239, 593, 253) // 右下
      ctx.quadraticCurveTo(578, 287, 578, 283) // 左下
      ctx.quadraticCurveTo(452, 211, 417, 163)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
      // stitch
      ctx.lineWidth = 1.2
      ctx.strokeStyle = state.stitch.color
      ctx.setLineDash([3, 3])
      ctx.beginPath()
      ctx.moveTo(569, 272) // 左下
      ctx.quadraticCurveTo(465, 215, 418, 155) // 左上
      ctx.quadraticCurveTo(417, 143, 448, 148) // 右上
      ctx.quadraticCurveTo(500, 200, 582, 252)
      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      ctx.strokeStyle = '#fff'

      break
    }
  }

  ctx.fillStyle = state.tongueLinings.color
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'
  switch (state.openingPattern.value) {
    case 'quarterCut':
      {
        // 外側の補強パーツ-裏地
        ctx.beginPath()
        ctx.moveTo(453, 77)
        ctx.quadraticCurveTo(463, 53, 507, 123) // 右下＿右
        ctx.quadraticCurveTo(505, 130, 505, 130) // 右下＿左
        ctx.quadraticCurveTo(458, 67, 453, 77)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
      }
      break
    default: {
      // // 外側の補強パーツ-裏地
      // ctx.beginPath()
      // ctx.moveTo(472, 97)
      // ctx.quadraticCurveTo(482, 73, 526, 143) // 右下＿右
      // ctx.quadraticCurveTo(524, 150, 524, 150) // 右下＿左
      // ctx.quadraticCurveTo(477, 87, 472, 97)
      // ctx.fill()
      // ctx.closePath()
    }
  }

  // レース
  if (state.vampStrapType.value === 'laceType') {
    // 紐穴
    if (state.openingPattern.value === 'quarterCut') {
      laceHole(ctx, state, 436, 141)
    }
    laceHole(ctx, state, 457, 168)
    laceHole(ctx, state, 482, 190)
    laceHole(ctx, state, 509, 215)
    laceHole(ctx, state, 539, 239)
    laceHole(ctx, state, 564, 258)

    laceOfLeftFoot1(ctx, state)
    laceOfLeftFoot1(ctx, state, -25, -15)
    laceOfLeftFoot1(ctx, state, -50, -32)
    laceOfLeftFoot1(ctx, state, -80, -58)
    laceOfLeftFoot1(ctx, state, -100, -77)
    laceOfLeftFoot2(ctx, state)
    laceOfLeftFoot2(ctx, state, -25, -18)
    laceOfLeftFoot2(ctx, state, -54, -38)
    laceOfLeftFoot2(ctx, state, -80, -60)
    laceOfLeftFoot2(ctx, state, -105, -85)
  }

  // ctx.strokeStyle = 'red'
  // ctx.beginPath()
  // ctx.moveTo(0, 0)
  //// ctx.quadraticCurveTo()
  // ctx.stroke()
  // ctx.closePath()

  const turnAroundMetalFittings = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
    ctx.strokeStyle = '#ccc'
    ctx.lineWidth = 4.0
    ctx.beginPath()
    ctx.moveTo(493 + x, 168 + y)
    ctx.quadraticCurveTo(487 + x, 161 + y, 500 + x, 161 + y)
    ctx.moveTo(514 + x, 184 + y)
    ctx.quadraticCurveTo(522 + x, 182 + y, 519 + x, 178 + y)
    ctx.stroke()
    ctx.closePath()
    ctx.lineWidth = 1.0
  }
  const magicBeltTurnAround = (ctx: CanvasRenderingContext2D, beltColor: string, state: ShoesState, x = 0, y = 0): void => {
    ctx.lineWidth = 0.8
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = beltColor
    ctx.beginPath()
    ctx.moveTo(576 + x, 232 + y) // 左下
    ctx.quadraticCurveTo(555 + x, 216 + y, 555 + x, 216 + y) // 左上
    ctx.quadraticCurveTo(572 + x, 199 + y, 581 + x, 177 + y) // 右上
    ctx.quadraticCurveTo(598 + x, 175 + y, 600 + x, 199 + y) // 右下
    ctx.quadraticCurveTo(593 + x, 217 + y, 576 + x, 232 + y) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // stitch
    ctx.lineWidth = 1.2
    ctx.strokeStyle = state.stitch.color
    ctx.setLineDash([3, 3])
    ctx.beginPath()
    ctx.moveTo(560 + x, 216 + y) // 左下
    ctx.quadraticCurveTo(577 + x, 195 + y, 583 + x, 180 + y)
    ctx.moveTo(575 + x, 227 + y) //
    ctx.quadraticCurveTo(603 + x, 202 + y, 594 + x, 187 + y)
    ctx.moveTo(575 + x, 193 + y)
    ctx.quadraticCurveTo(589 + x, 214 + y, 589 + x, 214 + y)
    ctx.moveTo(579 + x, 187 + y)
    ctx.quadraticCurveTo(594 + x, 207 + y, 594 + x, 207 + y)
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 1.0
  }
  const magicBeltTurnAroundReverse = (ctx: CanvasRenderingContext2D, beltColor: string, state: ShoesState, x = 0, y = 0) => {
    ctx.lineWidth = 1.0
    ctx.fillStyle = beltColor
    ctx.strokeStyle = '#383838'
    ctx.beginPath()
    ctx.moveTo(529, 227) // 左下
    ctx.quadraticCurveTo(513, 228, 494, 215) // 左上
    ctx.quadraticCurveTo(523, 198, 547, 161) // 右上
    ctx.quadraticCurveTo(557, 160, 564, 175) // 右下
    ctx.quadraticCurveTo(542, 219, 529, 227)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // stitch
    ctx.lineWidth = 1.2
    ctx.strokeStyle = state.stitch.color
    ctx.setLineDash([3, 3])
    ctx.beginPath()
    ctx.moveTo(548, 165)
    ctx.quadraticCurveTo(524, 201, 503, 214)
    ctx.quadraticCurveTo(527, 228, 537, 212)
    ctx.quadraticCurveTo(546, 201, 560, 175)
    ctx.moveTo(521, 200)
    ctx.quadraticCurveTo(542, 204, 542, 204)
    ctx.moveTo(528, 191)
    ctx.quadraticCurveTo(550, 194, 550, 194)
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
  }

  if (state.vampStrapType.value === 'beltTypeSameDirection') {
    turnAroundMetalFittings(ctx, state) // 上
    turnAroundMetalFittings(ctx, state, 28, 26) // 中
    turnAroundMetalFittings(ctx, state, 60, 52) // 下
    const belt1Color = state.vampStrapBelt1.color
    magicBeltTurnAround(ctx, belt1Color, state, -60, -52)
    const belt2Color = state.vampStrapBelt2.color
    magicBeltTurnAround(ctx, belt2Color, state, -32, -25)
    const belt3Color = state.vampStrapBelt3.color
    magicBeltTurnAround(ctx, belt3Color, state, 0, 0)
  }
  if (state.vampStrapType.value === 'beltTypeReverseDirection') {
    turnAroundMetalFittings(ctx, state) // 上
    turnAroundMetalFittings(ctx, state, 60, 52) // 下

    const belt1Color = state.vampStrapBelt1.color
    magicBeltTurnAround(ctx, belt1Color, state, -60, -52)
    const belt2Color = state.vampStrapBelt2.color
    magicBeltTurnAroundReverse(ctx, belt2Color, state)
    const belt3Color = state.vampStrapBelt3.color
    magicBeltTurnAround(ctx, belt3Color, state, 0, 0)
  }
}
// つま先補強
const toeReinforcementRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#fff'
  ctx.fillStyle = state.toeReinforcement.color
  ctx.beginPath()
  // 左の耳から
  ctx.moveTo(281, 438) // 左上
  ctx.quadraticCurveTo(281, 428, 287, 429) // 右上
  ctx.quadraticCurveTo(317, 417, 317, 417)
  ctx.quadraticCurveTo(322, 435, 322, 435)
  ctx.quadraticCurveTo(327, 450, 345, 447)
  ctx.quadraticCurveTo(369, 442, 395, 428)
  ctx.quadraticCurveTo(408, 419, 393, 389) // 右耳の左上
  ctx.quadraticCurveTo(426, 388, 426, 388)
  ctx.quadraticCurveTo(445, 429, 442, 445)
  ctx.quadraticCurveTo(430, 496, 439, 523)
  ctx.quadraticCurveTo(443, 555, 478, 613) // 右下
  ctx.quadraticCurveTo(430, 677, 356, 631) // 左下
  ctx.quadraticCurveTo(368, 565, 344, 535)
  ctx.quadraticCurveTo(335, 520, 289, 470)
  ctx.quadraticCurveTo(287, 452, 281, 438)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(359, 633) // 左下
  ctx.quadraticCurveTo(388, 541, 294, 470)
  ctx.quadraticCurveTo(286, 436, 286, 436) // 左耳＿左上
  ctx.quadraticCurveTo(314, 423, 314, 423) // 左耳＿右上
  ctx.quadraticCurveTo(321, 453, 338, 453)
  ctx.quadraticCurveTo(397, 433, 397, 433)
  ctx.quadraticCurveTo(411, 425, 400, 395)
  ctx.quadraticCurveTo(424, 395, 424, 395)
  ctx.quadraticCurveTo(445, 439, 434, 460)
  ctx.quadraticCurveTo(420, 532, 473, 615)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(364, 636) // 左下
  ctx.quadraticCurveTo(388, 541, 310, 478)
  ctx.quadraticCurveTo(432, 439, 434, 439)
  ctx.quadraticCurveTo(410, 528, 469, 620)

  ctx.moveTo(301, 485)
  ctx.quadraticCurveTo(442, 439, 442, 439)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0

  if (state.vampStrapType.value === 'laceType') {
    // 紐穴
    laceHole(ctx, state, 302, 448)
    laceHole(ctx, state, 418, 409)

    // 一番下の紐
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.vampStrap.color
    ctx.beginPath()
    ctx.moveTo(305, 452) // 左下
    ctx.quadraticCurveTo(295, 448, 303, 442) // 左上
    ctx.quadraticCurveTo(360, 414, 416, 405) // 右上
    ctx.quadraticCurveTo(424, 407, 419, 414) // 右下
    ctx.quadraticCurveTo(361, 428, 305, 452)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }
}
// つま先補強
const toeReinforcementLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.toeReinforcement.color
  ctx.beginPath()
  ctx.moveTo(570, 280) // 左耳_左
  ctx.quadraticCurveTo(587, 248, 587, 248) // 左耳_右
  ctx.quadraticCurveTo(612, 262, 617, 259)
  ctx.quadraticCurveTo(634, 246, 636, 228)
  ctx.quadraticCurveTo(633, 222, 612, 208)
  ctx.quadraticCurveTo(618, 203, 618, 203) // 右耳_右
  ctx.quadraticCurveTo(643, 215, 661, 229)
  ctx.quadraticCurveTo(680, 238, 727, 272)
  ctx.quadraticCurveTo(757, 292, 760, 324)
  ctx.quadraticCurveTo(759, 372, 721, 376) // 左下
  ctx.quadraticCurveTo(727, 375, 726, 362)
  ctx.quadraticCurveTo(721, 285, 616, 296)
  ctx.quadraticCurveTo(581, 289, 569, 280)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 断面
  ctx.strokeStyle = '#fff'
  ctx.fillStyle = state.toeReinforcement.color
  ctx.beginPath()
  ctx.moveTo(570, 280) // 左耳_左
  ctx.quadraticCurveTo(587, 248, 587, 248) // 左耳_右
  ctx.quadraticCurveTo(612, 262, 617, 259)
  ctx.quadraticCurveTo(634, 246, 636, 228)
  ctx.quadraticCurveTo(633, 222, 612, 208)
  ctx.quadraticCurveTo(618, 203, 618, 203) // 右耳_右

  ctx.moveTo(721, 376) // 左下
  ctx.quadraticCurveTo(727, 375, 726, 362)
  ctx.quadraticCurveTo(721, 285, 616, 296)
  ctx.quadraticCurveTo(581, 289, 569, 280)
  // ctx.quadraticCurveTo()
  // ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.3
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(728, 374) // 左下
  ctx.quadraticCurveTo(735, 282, 613, 293)
  ctx.quadraticCurveTo(576, 280, 576, 280) // 左耳_左
  ctx.quadraticCurveTo(590, 253, 590, 253) // 左耳_右
  ctx.quadraticCurveTo(610, 268, 620, 262)
  ctx.quadraticCurveTo(633, 253, 640, 230)
  ctx.quadraticCurveTo(638, 218, 618, 210)

  ctx.moveTo(731, 372) // 左下
  ctx.quadraticCurveTo(738, 282, 627, 290)
  ctx.quadraticCurveTo(656, 231, 658, 226)

  ctx.moveTo(629, 294)
  ctx.quadraticCurveTo(660, 230, 660, 230)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0

  if (state.vampStrapType.value === 'laceType') {
    laceHole(ctx, state, 595, 272)

    // 一番下の紐
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.vampStrap.color
    ctx.beginPath()
    ctx.moveTo(600, 274) // 左下
    ctx.quadraticCurveTo(593, 277, 592, 271) // 左上
    ctx.quadraticCurveTo(625, 210, 625, 210) // 右上
    ctx.quadraticCurveTo(629, 210, 632, 216) // 右下
    ctx.quadraticCurveTo(618, 248, 600, 274)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }
}
// 横側補強
const sideReinforcementRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#fff'
  ctx.fillStyle = state.sideReinforcement.color

  ctx.beginPath()
  ctx.moveTo(243, 435)
  ctx.quadraticCurveTo(290, 469, 290, 469)
  ctx.quadraticCurveTo(297, 485, 314, 497)
  ctx.quadraticCurveTo(343, 522, 352, 546)
  ctx.quadraticCurveTo(365, 593, 355, 630) // 左下
  ctx.quadraticCurveTo(340, 575, 320, 552)
  ctx.quadraticCurveTo(311, 537, 289, 527)
  ctx.quadraticCurveTo(251, 516, 251, 516) // 左下＿左
  ctx.quadraticCurveTo(244, 498, 243, 477)
  ctx.quadraticCurveTo(254, 487, 279, 492) // デザインの谷間
  ctx.quadraticCurveTo(239, 472, 240, 460)
  ctx.quadraticCurveTo(236, 438, 243, 435)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#383838'
  ctx.beginPath()
  ctx.moveTo(437, 420) // 左上
  ctx.quadraticCurveTo(440, 413, 439, 401) // 右上
  ctx.quadraticCurveTo(446, 407, 463, 460)
  ctx.quadraticCurveTo(459, 491, 466, 531)
  ctx.quadraticCurveTo(476, 573, 478, 613)
  ctx.quadraticCurveTo(398, 564, 437, 420)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 断面
  ctx.strokeStyle = '#fff'
  ctx.beginPath()
  ctx.moveTo(437, 420) // 左上
  ctx.quadraticCurveTo(440, 413, 439, 401) // 右上
  ctx.moveTo(463, 460)
  ctx.quadraticCurveTo(459, 491, 466, 531)
  ctx.quadraticCurveTo(476, 573, 478, 613)
  ctx.quadraticCurveTo(398, 564, 437, 420)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(356, 627) // 左下
  ctx.quadraticCurveTo(331, 513, 251, 515)
  ctx.moveTo(359, 627) // 左下
  ctx.quadraticCurveTo(334, 510, 254, 512)
  ctx.moveTo(245, 483)
  ctx.quadraticCurveTo(262, 493, 286, 493)
  ctx.quadraticCurveTo(254, 478, 243, 465)

  ctx.moveTo(285, 471) // 左上
  ctx.quadraticCurveTo(243, 441, 243, 441)
  ctx.moveTo(288, 477) // 左上
  ctx.quadraticCurveTo(243, 445, 243, 445)

  ctx.moveTo(473, 606)
  ctx.quadraticCurveTo(473, 573, 464, 544)
  ctx.quadraticCurveTo(456, 498, 460, 460)
  ctx.moveTo(470, 606)
  ctx.quadraticCurveTo(470, 573, 461, 544)
  ctx.quadraticCurveTo(450, 478, 460, 452)

  ctx.moveTo(439, 420)
  ctx.quadraticCurveTo(443, 411, 443, 411)
  ctx.moveTo(441, 424)
  ctx.quadraticCurveTo(445, 415, 445, 415)

  ctx.moveTo(451, 436)
  ctx.quadraticCurveTo(449, 440, 449, 440)
  ctx.moveTo(454, 439)
  ctx.quadraticCurveTo(451, 442, 451, 442)
  // ctx.moveTo()
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0
}
// 横側補強
const sideReinforcementLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#fff'
  ctx.fillStyle = state.sideReinforcement.color

  ctx.beginPath()
  ctx.moveTo(604, 291) // 頂点
  ctx.quadraticCurveTo(662, 270, 717, 310)
  ctx.quadraticCurveTo(755, 350, 722, 376) // 右下
  ctx.quadraticCurveTo(715, 338, 660, 329)
  ctx.quadraticCurveTo(639, 326, 614, 338)
  ctx.quadraticCurveTo(581, 352, 571, 350) // 左下
  ctx.quadraticCurveTo(545, 327, 545, 327)
  ctx.quadraticCurveTo(552, 338, 596, 319) // デザインの谷間
  ctx.quadraticCurveTo(554, 329, 543, 325)
  ctx.quadraticCurveTo(533, 320, 523, 306)
  ctx.quadraticCurveTo(525, 303, 525, 303)
  ctx.quadraticCurveTo(549, 308, 604, 291)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])

  ctx.moveTo(527, 307) //
  ctx.quadraticCurveTo(562, 309, 603, 294)
  ctx.moveTo(527, 310) //
  ctx.quadraticCurveTo(562, 312, 608, 296)

  ctx.moveTo(542, 323) //
  ctx.quadraticCurveTo(564, 325, 603, 317)
  ctx.quadraticCurveTo(567, 340, 553, 333)
  // ctx.quadraticCurveTo()

  ctx.moveTo(568, 348) //
  ctx.quadraticCurveTo(586, 348, 629, 329)
  ctx.quadraticCurveTo(700, 314, 724, 372)
  ctx.moveTo(568, 345) //
  ctx.quadraticCurveTo(586, 345, 629, 326)
  ctx.quadraticCurveTo(700, 311, 724, 369)

  // ctx.moveTo() //
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0
}
// atomsデザイン
const atomsDesignRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const lineType = state.lineType.value
  const isDoubleLine = lineType === 'doubleLine'
  ctx.strokeStyle = isDoubleLine ? state.line2.color : '#383838'
  ctx.lineWidth = isDoubleLine ? 4 : 1
  ctx.fillStyle = state.line.color

  ctx.beginPath()
  ctx.moveTo(223, 252) // 頂点
  ctx.quadraticCurveTo(223, 292, 223, 292)
  ctx.quadraticCurveTo(235, 318, 235, 318) // くぼみ
  ctx.quadraticCurveTo(238, 281, 238, 281)
  ctx.quadraticCurveTo(245, 298, 245, 298)
  ctx.quadraticCurveTo(243, 331, 243, 331) // くぼみ
  ctx.quadraticCurveTo(265, 361, 265, 361)
  ctx.quadraticCurveTo(272, 370, 274, 400)
  ctx.quadraticCurveTo(271, 460, 260, 473) // 手前＿下
  ctx.quadraticCurveTo(262, 449, 256, 424) // 手前くぼみ
  ctx.quadraticCurveTo(236, 434, 238, 450)
  ctx.quadraticCurveTo(235, 418, 235, 418)
  ctx.quadraticCurveTo(232, 406, 251, 392)
  ctx.quadraticCurveTo(238, 368, 238, 368)
  ctx.quadraticCurveTo(230, 393, 236, 406)
  ctx.quadraticCurveTo(234, 410, 234, 410)
  ctx.quadraticCurveTo(227, 372, 230, 356)
  ctx.quadraticCurveTo(217, 330, 213, 280)
  ctx.quadraticCurveTo(223, 252, 223, 252)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = isDoubleLine ? state.line2.color : '#383838'
  ctx.beginPath()
  ctx.moveTo(360, 228)
  ctx.quadraticCurveTo(384, 269, 389, 295)
  ctx.quadraticCurveTo(400, 314, 403, 331)
  ctx.quadraticCurveTo(427, 376, 440, 408)
  ctx.quadraticCurveTo(441, 404, 441, 404)
  ctx.quadraticCurveTo(360, 228, 360, 228)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  ctx.lineWidth = 0.5
  ctx.strokeStyle = '#fff'
  ctx.beginPath()
  ctx.moveTo(223, 252) // 頂点
  ctx.quadraticCurveTo(223, 292, 223, 292)
  ctx.quadraticCurveTo(235, 318, 235, 318) // くぼみ
  ctx.quadraticCurveTo(238, 281, 238, 281)
  ctx.quadraticCurveTo(245, 298, 245, 298)
  ctx.quadraticCurveTo(243, 331, 243, 331) // くぼみ
  ctx.quadraticCurveTo(265, 361, 265, 361)
  ctx.quadraticCurveTo(272, 370, 274, 400)
  ctx.quadraticCurveTo(271, 460, 260, 473) // 手前＿下
  ctx.quadraticCurveTo(262, 449, 256, 424) // 手前くぼみ
  ctx.quadraticCurveTo(236, 434, 238, 450)
  ctx.quadraticCurveTo(235, 418, 235, 418)
  ctx.quadraticCurveTo(232, 406, 251, 392)
  ctx.quadraticCurveTo(238, 368, 238, 368)
  ctx.quadraticCurveTo(230, 393, 236, 406)
  ctx.quadraticCurveTo(234, 410, 234, 410)
  ctx.quadraticCurveTo(227, 372, 230, 356)
  ctx.quadraticCurveTo(217, 330, 213, 280)
  ctx.quadraticCurveTo(223, 252, 223, 252)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(360, 228)
  ctx.quadraticCurveTo(384, 269, 389, 295)
  ctx.quadraticCurveTo(400, 314, 403, 331)
  ctx.quadraticCurveTo(427, 376, 440, 408)
  ctx.quadraticCurveTo(441, 404, 441, 404)
  ctx.quadraticCurveTo(360, 228, 360, 228)
  ctx.stroke()
  ctx.closePath()

  const onStitchColor = darkenColor(state.line.color, 0.3)
  ctx.lineWidth = 1.2
  ctx.strokeStyle = onStitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(216, 282) // 頂点
  ctx.quadraticCurveTo(218, 275, 220, 272)
  ctx.quadraticCurveTo(220, 292, 220, 292)
  ctx.quadraticCurveTo(238, 331, 238, 331)
  ctx.quadraticCurveTo(240, 298, 240, 298)
  ctx.quadraticCurveTo(240, 338, 240, 338)
  ctx.quadraticCurveTo(265, 370, 265, 370) // vampStrapReinforcementとの接点
  ctx.quadraticCurveTo(270, 393, 270, 393) // vampStrapReinforcementとの接点
  ctx.quadraticCurveTo(268, 436, 265, 456)
  ctx.quadraticCurveTo(260, 415, 260, 415)
  ctx.quadraticCurveTo(239, 431, 239, 431)

  // ctx.quadraticCurveTo(238, 415, 238, 415)
  ctx.moveTo(238, 415)
  ctx.quadraticCurveTo(240, 407, 256, 394)
  ctx.quadraticCurveTo(237, 358, 237, 358)
  ctx.quadraticCurveTo(231, 377, 231, 377)
  ctx.quadraticCurveTo(235, 353, 235, 353)
  ctx.quadraticCurveTo(221, 328, 216, 282)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  ctx.lineWidth = 1
}
// atomsデザイン
const atomsDesignLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const lineType = state.lineType.value
  const isDoubleLine = lineType === 'doubleLine'
  ctx.strokeStyle = isDoubleLine ? state.line2.color : '#383838'
  ctx.lineWidth = isDoubleLine ? 4 : 1
  ctx.fillStyle = state.line.color

  ctx.beginPath()
  ctx.moveTo(391, 180) // 頂点
  ctx.quadraticCurveTo(388, 204, 389, 218)
  ctx.quadraticCurveTo(403, 237, 403, 237)
  ctx.quadraticCurveTo(423, 250, 455, 259)
  ctx.quadraticCurveTo(474, 278, 501, 290)
  ctx.quadraticCurveTo(475, 264, 475, 264)
  ctx.quadraticCurveTo(505, 271, 505, 271)
  ctx.quadraticCurveTo(501, 290, 501, 290) // 中心の逆三角の右下
  ctx.quadraticCurveTo(526, 311, 526, 311) // 右下
  ctx.quadraticCurveTo(523, 301, 531, 288) // くぼみ
  ctx.quadraticCurveTo(553, 300, 568, 315) // 右端下
  ctx.quadraticCurveTo(559, 291, 530, 251)
  ctx.quadraticCurveTo(508, 241, 508, 241)
  ctx.quadraticCurveTo(459, 236, 459, 236) // くぼみ
  ctx.quadraticCurveTo(437, 179, 437, 179)
  ctx.quadraticCurveTo(423, 163, 423, 163)
  ctx.quadraticCurveTo(446, 232, 446, 232)
  ctx.quadraticCurveTo(409, 221, 409, 221)
  ctx.quadraticCurveTo(391, 180, 391, 180)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 0.8

  ctx.beginPath()
  ctx.moveTo(391, 180) // 頂点
  ctx.quadraticCurveTo(388, 204, 389, 218)
  ctx.quadraticCurveTo(403, 237, 403, 237)
  ctx.quadraticCurveTo(423, 250, 455, 259)
  ctx.quadraticCurveTo(474, 278, 501, 290)
  ctx.quadraticCurveTo(475, 264, 475, 264)
  ctx.quadraticCurveTo(505, 271, 505, 271)
  ctx.quadraticCurveTo(501, 290, 501, 290) // 中心の逆三角の右下
  ctx.quadraticCurveTo(526, 311, 526, 311) // 右下
  ctx.quadraticCurveTo(523, 301, 531, 288) // くぼみ
  ctx.quadraticCurveTo(553, 300, 568, 315) // 右端下
  ctx.quadraticCurveTo(559, 291, 530, 251)
  ctx.quadraticCurveTo(508, 241, 508, 241)
  ctx.quadraticCurveTo(459, 236, 459, 236) // くぼみ
  ctx.quadraticCurveTo(437, 179, 437, 179)
  ctx.quadraticCurveTo(423, 163, 423, 163)
  ctx.quadraticCurveTo(446, 232, 446, 232)
  ctx.quadraticCurveTo(409, 221, 409, 221)
  ctx.quadraticCurveTo(391, 180, 391, 180)
  ctx.stroke()
  ctx.closePath()

  const onStitchColor = darkenColor(state.line.color, 0.3)

  ctx.lineWidth = 1.2
  ctx.strokeStyle = onStitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.stroke()
  ctx.moveTo(392, 216)
  ctx.quadraticCurveTo(393, 191, 393, 191)
  ctx.quadraticCurveTo(406, 225, 406, 225)
  ctx.quadraticCurveTo(450, 237, 450, 237)
  ctx.quadraticCurveTo(431, 180, 431, 180)
  ctx.quadraticCurveTo(436, 186, 436, 186)
  ctx.quadraticCurveTo(456, 240, 456, 240)
  ctx.quadraticCurveTo(510, 245, 510, 245)
  ctx.quadraticCurveTo(529, 258, 529, 258)
  ctx.quadraticCurveTo(557, 300, 557, 300)
  ctx.quadraticCurveTo(529, 282, 529, 282)
  ctx.quadraticCurveTo(519, 298, 522, 304)

  ctx.moveTo(438, 252)
  ctx.quadraticCurveTo(460, 256, 460, 258)
  ctx.quadraticCurveTo(470, 272, 484, 278)

  ctx.moveTo(480, 275)
  ctx.quadraticCurveTo(464, 258, 464, 258)
  ctx.quadraticCurveTo(509, 269, 509, 269)
  ctx.quadraticCurveTo(504, 291, 504, 291)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  ctx.lineWidth = 1
}
const healDecorationRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.healDecoration.color
  ctx.beginPath()
  ctx.moveTo(222, 140) // 頂点
  ctx.quadraticCurveTo(215, 166, 212, 177)
  ctx.quadraticCurveTo(205, 190, 207, 197) //左下
  ctx.quadraticCurveTo(212, 194, 212, 194) //右下
  ctx.quadraticCurveTo(217, 182, 222, 140)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
} // かかと飾り
const healDecorationLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const openingPattern = state.openingPattern.value

  switch (openingPattern) {
    case 'quarterCut': {
      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.healDecoration.color
      ctx.beginPath()
      ctx.moveTo(326, 106)
      ctx.quadraticCurveTo(326, 82, 333, 78)
      ctx.quadraticCurveTo(322, 108, 347, 141) // 右下
      ctx.quadraticCurveTo(335, 149, 335, 149) // 中央下
      ctx.quadraticCurveTo(324, 141, 324, 124)
      ctx.quadraticCurveTo(326, 106, 326, 106)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // 断面
      ctx.strokeStyle = '#fff'
      ctx.beginPath()
      ctx.moveTo(347, 141)
      ctx.quadraticCurveTo(335, 149, 335, 149) // 中央下
      ctx.quadraticCurveTo(324, 141, 324, 124)
      // ctx.fill()
      ctx.stroke()
      ctx.closePath()

      ctx.lineWidth = 1.2
      ctx.strokeStyle = state.stitch.color
      ctx.beginPath()
      ctx.setLineDash([3, 3])
      ctx.moveTo(326, 125)
      ctx.quadraticCurveTo(330, 153, 342, 139)
      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      ctx.lineWidth = 1.0
      break
    }
    default: {
      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.healDecoration.color
      ctx.beginPath()
      ctx.moveTo(326, 120) // 左下
      ctx.quadraticCurveTo(326, 82, 335, 78)
      ctx.quadraticCurveTo(325, 108, 343, 132) // 右下
      ctx.quadraticCurveTo(343, 140, 343, 140)
      ctx.quadraticCurveTo(327, 130, 326, 120)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // 断面
      ctx.strokeStyle = '#fff'
      ctx.beginPath()
      ctx.moveTo(326, 120) // 左下
      ctx.quadraticCurveTo(327, 130, 343, 140) // 中央下
      // ctx.fill()
      ctx.stroke()
      ctx.closePath()

      ctx.lineWidth = 1.2
      ctx.strokeStyle = state.stitch.color
      ctx.beginPath()
      ctx.setLineDash([3, 3])
      ctx.moveTo(328, 117) // 左下
      ctx.quadraticCurveTo(327, 123, 341, 135) // 中央下
      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
      ctx.lineWidth = 1.0
    }
  }
} // かかと飾り
const healReinforcementLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.healReinforcement.color
  ctx.beginPath()
  ctx.moveTo(324, 134)
  ctx.quadraticCurveTo(361, 222, 443, 256)
  ctx.quadraticCurveTo(362, 242, 337, 222)
  ctx.quadraticCurveTo(316, 174, 324, 134)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 断面
  ctx.strokeStyle = '#fff'
  ctx.beginPath()
  ctx.moveTo(324, 134)
  ctx.quadraticCurveTo(361, 222, 443, 256)
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(322, 137)
  ctx.quadraticCurveTo(359, 225, 438, 255)
  ctx.moveTo(322, 142)
  ctx.quadraticCurveTo(357, 230, 438, 255)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0
} // かかと補強
const mainUnitRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.mainUnit.color
  ctx.beginPath()
  ctx.moveTo(221, 141)
  ctx.quadraticCurveTo(298, 150, 298, 150)
  ctx.quadraticCurveTo(364, 242, 364, 242)
  ctx.quadraticCurveTo(400, 307, 462, 460) // サイド補強＿横
  ctx.quadraticCurveTo(495, 539, 477, 614) // つま先横＿内側
  ctx.quadraticCurveTo(354, 631, 354, 631)
  ctx.quadraticCurveTo(282, 570, 253, 518)
  ctx.quadraticCurveTo(235, 437, 230, 358)
  ctx.quadraticCurveTo(219, 266, 219, 266)
  ctx.quadraticCurveTo(206, 226, 208, 199)
  ctx.quadraticCurveTo(221, 141, 221, 141)
  // ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
} // 本体
const mainUnitLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.mainUnit.color

  switch (state.openingPattern.value) {
    case 'quarterCut': {
      ctx.beginPath()
      ctx.moveTo(400, 125)
      ctx.quadraticCurveTo(721, 350, 721, 350) // 右上
      ctx.quadraticCurveTo(722, 376, 722, 376) // 右下
      ctx.quadraticCurveTo(646, 380, 572, 350)
      ctx.quadraticCurveTo(525, 310, 500, 290)
      ctx.quadraticCurveTo(450, 245, 440, 255)
      ctx.quadraticCurveTo(364, 224, 324, 134) // 左上
      ctx.quadraticCurveTo(346, 140, 346, 140)
      ctx.quadraticCurveTo(362, 158, 400, 125)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
      break
    }
    default:
      ctx.beginPath()
      ctx.moveTo(438, 156) // 頂点
      ctx.quadraticCurveTo(721, 350, 721, 350) // 右下_1
      ctx.quadraticCurveTo(722, 376, 722, 376) // 右下
      ctx.quadraticCurveTo(646, 380, 572, 350)
      ctx.quadraticCurveTo(525, 310, 500, 290)
      ctx.quadraticCurveTo(450, 245, 440, 255)
      ctx.quadraticCurveTo(340, 218, 324, 153)
      ctx.quadraticCurveTo(328, 118, 326, 118) // 左上
      ctx.quadraticCurveTo(346, 140, 346, 140)
      ctx.quadraticCurveTo(379, 190, 438, 156)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
      break
  }
} // 本体

const atomsMarkRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  if (state.atomsLabel.value === 'unselected') return

  const baseColor = '#1e1e1e'
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = baseColor
  ctx.beginPath()
  ctx.moveTo(238 + x, 153 + y) // 左上
  ctx.quadraticCurveTo(248 + x, 139 + y, 267 + x, 135 + y) // 右上
  ctx.quadraticCurveTo(282 + x, 146 + y, 282 + x, 146 + y) // 右上の溝
  ctx.quadraticCurveTo(295 + x, 136 + y, 295 + x, 136 + y)
  ctx.quadraticCurveTo(310 + x, 131 + y, 308 + x, 150 + y)
  ctx.quadraticCurveTo(299 + x, 161 + y, 299 + x, 161 + y)
  ctx.quadraticCurveTo(308 + x, 149 + y, 317 + x, 164 + y)
  ctx.quadraticCurveTo(314 + x, 185 + y, 314 + x, 185 + y)
  ctx.quadraticCurveTo(298 + x, 191 + y, 298 + x, 191 + y)
  ctx.quadraticCurveTo(292 + x, 191 + y, 279 + x, 180 + y)
  ctx.quadraticCurveTo(270 + x, 201 + y, 270 + x, 201 + y)
  ctx.quadraticCurveTo(246 + x, 210 + y, 246 + x, 207 + y) // 左下
  ctx.quadraticCurveTo(240 + x, 201 + y, 248 + x, 189 + y)
  ctx.quadraticCurveTo(249 + x, 177 + y, 249 + x, 164 + y)
  ctx.quadraticCurveTo(238 + x, 165 + y, 238 + x, 153 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = 'gold'
  ctx.beginPath()
  ctx.moveTo(254 + x, 157 + y)
  ctx.quadraticCurveTo(244 + x, 157 + y, 244 + x, 157 + y)
  ctx.quadraticCurveTo(240 + x, 152 + y, 248 + x, 150 + y)
  ctx.quadraticCurveTo(264 + x, 142 + y, 264 + x, 142 + y) // 右上
  ctx.quadraticCurveTo(281 + x, 155 + y, 281 + x, 155 + y)
  ctx.quadraticCurveTo(297 + x, 142 + y, 297 + x, 142 + y)
  ctx.quadraticCurveTo(303 + x, 136 + y, 304 + x, 148 + y)
  ctx.quadraticCurveTo(290 + x, 162 + y, 290 + x, 162 + y)
  ctx.quadraticCurveTo(303 + x, 172 + y, 303 + x, 172 + y)
  ctx.quadraticCurveTo(306 + x, 163 + y, 306 + x, 163 + y)
  ctx.quadraticCurveTo(309 + x, 160 + y, 312 + x, 164 + y)
  ctx.quadraticCurveTo(310 + x, 180 + y, 310 + x, 180 + y)
  ctx.quadraticCurveTo(293 + x, 185 + y, 293 + x, 185 + y)
  ctx.quadraticCurveTo(278 + x, 173 + y, 278 + x, 173 + y) // 中央のくぼみ
  ctx.quadraticCurveTo(265 + x, 186 + y, 265 + x, 198 + y) // 左下
  ctx.quadraticCurveTo(249 + x, 205 + y, 249 + x, 205 + y)
  ctx.quadraticCurveTo(242 + x, 202 + y, 251 + x, 195 + y)
  ctx.quadraticCurveTo(254 + x, 157 + y, 254 + x, 157 + y)
  // ctx.quadraticCurveTo()
  // ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = baseColor

  ctx.beginPath()
  ctx.moveTo(266 + x, 160 + y)
  ctx.quadraticCurveTo(272 + x, 166 + y, 272 + x, 166 + y) // 右下
  ctx.quadraticCurveTo(265 + x, 175 + y, 265 + x, 175 + y) // 左下
  ctx.quadraticCurveTo(266 + x, 160 + y, 266 + x, 160 + y)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
} // atomsマーク
const atomsMarkLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0): void => {
  if (state.atomsLabel.value === 'unselected') return
  const baseColor = '#1e1e1e'
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = baseColor
  ctx.beginPath()
  ctx.moveTo(397 + x, 81 + y) // 左上
  ctx.quadraticCurveTo(401 + x, 70 + y, 413 + x, 61 + y) // 右上
  ctx.quadraticCurveTo(426 + x, 66 + y, 426 + x, 66 + y) // くぼみ
  ctx.quadraticCurveTo(425 + x, 59 + y, 425 + x, 59 + y)
  ctx.quadraticCurveTo(428 + x, 48 + y, 435 + x, 63 + y)
  ctx.quadraticCurveTo(440 + x, 73 + y, 440 + x, 73 + y)
  ctx.quadraticCurveTo(443 + x, 65 + y, 446 + x, 72 + y)
  ctx.quadraticCurveTo(454 + x, 78 + y, 459 + x, 90 + y) // 右下
  ctx.quadraticCurveTo(453 + x, 100 + y, 453 + x, 100 + y)
  ctx.quadraticCurveTo(440 + x, 96 + y, 440 + x, 96 + y)
  ctx.quadraticCurveTo(438 + x, 121 + y, 438 + x, 121 + y) // 左下
  ctx.quadraticCurveTo(431 + x, 135 + y, 431 + x, 135 + y)
  ctx.quadraticCurveTo(418 + x, 133 + y, 422 + x, 124 + y)
  ctx.quadraticCurveTo(419 + x, 113 + y, 419 + x, 113 + y)
  ctx.quadraticCurveTo(411 + x, 92 + y, 411 + x, 92 + y)
  ctx.quadraticCurveTo(394 + x, 94 + y, 397 + x, 81 + y)
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  ctx.fillStyle = 'gold'
  ctx.beginPath()
  ctx.moveTo(403 + x, 78 + y) // 左上
  ctx.quadraticCurveTo(415 + x, 66 + y, 415 + x, 66 + y) // 右上
  ctx.quadraticCurveTo(430 + x, 73 + y, 430 + x, 73 + y) // くぼみ
  ctx.quadraticCurveTo(433 + x, 64 + y, 430 + x, 58 + y)
  ctx.quadraticCurveTo(439 + x, 60 + y, 438 + x, 77 + y)
  ctx.quadraticCurveTo(448 + x, 82 + y, 448 + x, 82 + y)
  ctx.quadraticCurveTo(444 + x, 72 + y, 444 + x, 72 + y)
  ctx.quadraticCurveTo(453 + x, 79 + y, 457 + x, 88 + y)
  ctx.quadraticCurveTo(452 + x, 95 + y, 452 + x, 95 + y)
  ctx.quadraticCurveTo(436 + x, 87 + y, 436 + x, 87 + y) // くぼみ
  ctx.quadraticCurveTo(434 + x, 117 + y, 434 + x, 117 + y) // 左下
  ctx.quadraticCurveTo(429 + x, 130 + y, 429 + x, 130 + y)
  ctx.quadraticCurveTo(424 + x, 128 + y, 425 + x, 117 + y)
  ctx.quadraticCurveTo(414 + x, 83 + y, 414 + x, 83 + y)
  ctx.quadraticCurveTo(405 + x, 87 + y, 405 + x, 87 + y)
  ctx.quadraticCurveTo(397 + x, 87 + y, 403 + x, 78 + y)
  // ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.fillStyle = baseColor
  ctx.beginPath()
  ctx.moveTo(421 + x, 77 + y)
  ctx.quadraticCurveTo(430 + x, 83 + y, 430 + x, 83 + y)
  ctx.quadraticCurveTo(428 + x, 94 + y, 428 + x, 94 + y)
  ctx.quadraticCurveTo(421 + x, 77 + y, 421 + x, 77 + y)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
} // atomsマーク

const openingLiningRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  // かかと入れるところの色
  ctx.fillStyle = state.tongueLinings.color
  ctx.strokeStyle = '#383838'
  ctx.beginPath()
  ctx.moveTo(213, 194) // 左下
  ctx.quadraticCurveTo(222, 140, 222, 140) // 左上
  ctx.quadraticCurveTo(225, 126, 239, 123) // 頂点
  ctx.quadraticCurveTo(263, 119, 282, 132) // 右上
  ctx.quadraticCurveTo(287, 146, 312, 158)
  ctx.quadraticCurveTo(332, 196, 332, 226)
  ctx.quadraticCurveTo(236, 238, 236, 238) //
  ctx.quadraticCurveTo(213, 194, 213, 194)
  // ctx.quadraticCurveTo() //

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // opening側面のところ
  ctx.beginPath()
  ctx.moveTo(213, 196) // 左上
  ctx.quadraticCurveTo(221, 218, 227, 220) // 左下
  ctx.quadraticCurveTo(229, 216, 229, 216) //
  ctx.quadraticCurveTo(221, 194, 221, 194) //
  ctx.quadraticCurveTo(217, 193, 213, 196) // 左上
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  const coordinates = { x0: 0, y0: 0, x1: 900, y1: 750 }
  const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
  // // 影部分
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(225, 189) // 左下
  ctx.quadraticCurveTo(232, 180, 231, 158) // 左上
  ctx.quadraticCurveTo(243, 116, 274, 145)
  ctx.quadraticCurveTo(282, 160, 306, 171)
  ctx.quadraticCurveTo(322, 220, 322, 220)
  ctx.quadraticCurveTo(234, 227, 234, 227)
  ctx.quadraticCurveTo(225, 189, 225, 189)
  // ctx.quadraticCurveTo()
  // ctx.stroke()
  ctx.fill()
  ctx.closePath()
} // ベロ裏
const openingLiningLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  switch (state.openingPattern.value) {
    case 'quarterCut':
      const coordinates = { x0: 0, y0: 300, x1: 800, y1: 700 }
      const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
      // 影部分a
      ctx.fillStyle = gradient
      ctx.beginPath()
      ctx.moveTo(452, 78)
      ctx.quadraticCurveTo(468, 113, 505, 137)
      ctx.quadraticCurveTo(559, 183, 633, 226) // 右下
      ctx.quadraticCurveTo(633, 226, 633, 223) // 右下
      ctx.quadraticCurveTo(544, 163, 510, 127)
      ctx.quadraticCurveTo(461, 68, 452, 78)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      // ctx.stroke()
      ctx.fill()
      ctx.closePath()

      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.tongueLinings.color
      ctx.beginPath()
      ctx.moveTo(399, 127)
      ctx.quadraticCurveTo(368, 155, 348, 142)
      ctx.quadraticCurveTo(322, 107, 333, 78)
      ctx.quadraticCurveTo(355, 55, 374, 83)
      ctx.quadraticCurveTo(395, 113, 435, 93)
      ctx.quadraticCurveTo(447, 90, 453, 74)
      ctx.quadraticCurveTo(450, 150, 399, 127)
      // ctx.quadraticCurveTo()
      ctx.stroke()
      ctx.fill()
      ctx.closePath()

      // 影
      const coordinates2 = { x0: 0, y0: 300, x1: 800, y1: 700 }
      const gradient2 = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates2)
      ctx.fillStyle = gradient2
      ctx.beginPath()
      ctx.moveTo(342, 99) // かかと左
      ctx.quadraticCurveTo(343, 77, 362, 88)
      ctx.quadraticCurveTo(372, 100, 380, 102)
      ctx.quadraticCurveTo(409, 120, 448, 95)
      ctx.quadraticCurveTo(456, 153, 400, 124) //   右下
      ctx.quadraticCurveTo(400, 126, 400, 126)
      ctx.quadraticCurveTo(342, 153, 342, 99)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      // ctx.stroke()
      ctx.fill()
      ctx.closePath()
      break
    default: // lowCut, middleCut
      const coordinates3 = { x0: 0, y0: 300, x1: 800, y1: 700 }
      const gradient3 = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates3)
      // 影部分a
      ctx.fillStyle = gradient3
      ctx.beginPath()
      ctx.moveTo(452, 90)
      ctx.quadraticCurveTo(468, 113, 505, 137)
      ctx.quadraticCurveTo(559, 183, 633, 226) // 右下
      ctx.quadraticCurveTo(633, 226, 633, 223) // 右下
      ctx.quadraticCurveTo(544, 163, 510, 127)
      ctx.quadraticCurveTo(461, 68, 452, 90)
      // ctx.quadraticCurveTo()
      // ctx.quadraticCurveTo()
      // ctx.stroke()
      ctx.fill()
      ctx.closePath()

      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.tongueLinings.color
      ctx.beginPath()
      ctx.moveTo(429, 172) // 右下
      ctx.quadraticCurveTo(358, 175, 348, 142)
      ctx.quadraticCurveTo(322, 107, 333, 78)
      ctx.quadraticCurveTo(355, 55, 374, 83)
      ctx.quadraticCurveTo(395, 113, 435, 93)
      ctx.quadraticCurveTo(447, 90, 460, 80)
      ctx.quadraticCurveTo(465, 80, 465, 80)
      ctx.quadraticCurveTo(515, 120, 490, 133)
      ctx.quadraticCurveTo(450, 150, 429, 172) // 右下
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // // 影
      const coordinates4 = { x0: 0, y0: 300, x1: 800, y1: 700 }
      const gradient4 = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates4)
      ctx.fillStyle = gradient4
      ctx.beginPath()
      ctx.moveTo(342, 99) // かかと左
      ctx.quadraticCurveTo(343, 72, 362, 81)
      ctx.quadraticCurveTo(379, 104, 380, 104)
      ctx.quadraticCurveTo(405, 126, 457, 95)
      ctx.quadraticCurveTo(460, 95, 460, 95)
      ctx.quadraticCurveTo(465, 90, 465, 95)
      ctx.quadraticCurveTo(500, 131, 489, 131)
      // ctx.quadraticCurveTo()
      ctx.quadraticCurveTo(446, 183, 417, 142) //   右下
      ctx.quadraticCurveTo(362, 173, 342, 99)
      ctx.fill()
      ctx.closePath()
      break
  }
}

const healReinforcementRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  // かかとの部分
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.healReinforcement.color
  ctx.beginPath()
  ctx.moveTo(213, 282) // 左下
  ctx.quadraticCurveTo(206, 257, 209, 231)
  ctx.quadraticCurveTo(222, 270, 222, 270)
  ctx.quadraticCurveTo(213, 282, 213, 282)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
} //

// 紐
const outSolesLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  switch (state.outSole.value) {
    case 'pointSole': {
      // かかと側ここから
      ctx.strokeStyle = '#383838'
      ctx.fillStyle = '#FFFFFF'
      ctx.beginPath()
      ctx.moveTo(386, 255)
      ctx.quadraticCurveTo(393, 267, 393, 267)
      ctx.quadraticCurveTo(420, 272, 420, 272)
      ctx.quadraticCurveTo(421, 260, 421, 260)
      ctx.quadraticCurveTo(386, 255, 386, 255)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // フレーム部分
      ctx.beginPath()
      ctx.moveTo(369, 249) // 左下
      ctx.quadraticCurveTo(357, 232, 357, 232) // 左上
      ctx.quadraticCurveTo(397, 254, 435, 253)
      ctx.quadraticCurveTo(457, 263, 457, 263)
      ctx.quadraticCurveTo(399, 264, 369, 249)
      // ctx.quadraticCurveTo()
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
      // かかと側ここまで

      // つま先側ここから
      //// 歯1の部分
      ctx.beginPath()
      ctx.moveTo(538, 326) // 左上
      ctx.quadraticCurveTo(567, 352, 567, 352)
      ctx.quadraticCurveTo(560, 363, 553, 355)
      ctx.quadraticCurveTo(542, 343, 542, 343)
      ctx.quadraticCurveTo(538, 326, 538, 326)
      ctx.fill()
      ctx.moveTo(560, 349) // 左上
      ctx.quadraticCurveTo(560, 359, 560, 359)
      ctx.stroke()
      ctx.closePath()

      //// 歯2の部分
      ctx.beginPath()
      ctx.moveTo(581, 361) // 左上
      ctx.quadraticCurveTo(619, 375, 619, 375)
      ctx.quadraticCurveTo(614, 385, 614, 385)
      ctx.quadraticCurveTo(582, 375, 582, 375)
      ctx.quadraticCurveTo(581, 361, 581, 361)
      ctx.fill()
      // ctx.moveTo() // 左上
      // ctx.quadraticCurveTo()
      ctx.stroke()
      ctx.closePath()

      //// 歯3の部分
      ctx.beginPath()
      ctx.moveTo(641, 378) // 左上
      ctx.quadraticCurveTo(686, 384, 686, 384)
      ctx.quadraticCurveTo(678, 397, 678, 397)
      ctx.quadraticCurveTo(643, 392, 643, 392)
      ctx.quadraticCurveTo(641, 378, 641, 378)
      ctx.fill()
      // ctx.moveTo() // 左上
      // ctx.quadraticCurveTo()
      ctx.stroke()
      ctx.closePath()

      //// フレーム部分
      ctx.beginPath()
      ctx.moveTo(530, 315)
      ctx.quadraticCurveTo(555, 350, 585, 364)
      ctx.quadraticCurveTo(634, 383, 703, 385)
      ctx.quadraticCurveTo(745, 386, 754, 353) // 右端
      ctx.quadraticCurveTo(740, 382, 699, 376)
      ctx.quadraticCurveTo(580, 373, 530, 315)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      break
    }
    case 'resinSoleEvaWhiteCleats':
    case 'unselected':
      {
        // かかと側ここから
        ctx.strokeStyle = '#383838'
        ctx.fillStyle = '#bfbfbf'
        // フレーム部分
        ctx.beginPath()
        ctx.moveTo(369, 249) // 左下
        ctx.quadraticCurveTo(357, 232, 357, 232) // 左上
        ctx.quadraticCurveTo(397, 254, 435, 253)
        ctx.quadraticCurveTo(457, 263, 457, 263)
        ctx.quadraticCurveTo(399, 264, 369, 249)
        // ctx.quadraticCurveTo()
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.beginPath()
        ctx.moveTo(374, 252) // 左上
        ctx.quadraticCurveTo(378, 262, 378, 262) // 左下
        ctx.quadraticCurveTo(390, 263, 395, 259) // 右下
        ctx.quadraticCurveTo(374, 252, 374, 252)
        // ctx.quadraticCurveTo()
        ctx.stroke()
        ctx.fill()
        ctx.closePath()

        // 歯a
        ctx.fillStyle = '#44463F'
        ctx.beginPath()
        ctx.moveTo(378, 262) // 左上
        ctx.quadraticCurveTo(377, 272, 377, 272) // 左下
        ctx.quadraticCurveTo(380, 272, 380, 272) // 右下
        ctx.quadraticCurveTo(383, 262, 383, 262) // 右上
        ctx.quadraticCurveTo(378, 262, 378, 262)
        // ctx.quadraticCurveTo()
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.strokeStyle = '#383838'
        // かかと側ここまで

        // つま先ここから
        // 歯b
        ctx.fillStyle = '#44463F'
        ctx.beginPath()
        ctx.moveTo(537, 325) // 左上
        ctx.quadraticCurveTo(535, 355, 553, 349)
        ctx.quadraticCurveTo(555, 338, 555, 338)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()

        // 歯c
        ctx.beginPath()
        ctx.moveTo(612, 373) // 左上
        ctx.quadraticCurveTo(608, 386, 626, 385) // 中央左
        ctx.quadraticCurveTo(627, 378, 629, 384) // 中央右
        ctx.quadraticCurveTo(638, 383, 635, 378) // 右上
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.strokeStyle = '#383838'

        // 歯d
        ctx.fillStyle = '#44463F'
        ctx.beginPath()
        ctx.moveTo(714, 385) // 左上
        ctx.quadraticCurveTo(725, 397, 734, 378)
        // ctx.quadraticCurveTo()
        // ctx.quadraticCurveTo()
        // ctx.quadraticCurveTo()
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.strokeStyle = '#383838'

        // フレーム部分
        ctx.fillStyle = '#bfbfbf'
        ctx.beginPath()
        ctx.moveTo(530, 315)
        ctx.quadraticCurveTo(555, 350, 585, 364)
        ctx.quadraticCurveTo(634, 383, 703, 385)
        ctx.quadraticCurveTo(745, 386, 754, 353) // 右端
        ctx.quadraticCurveTo(740, 382, 699, 376)
        ctx.quadraticCurveTo(580, 373, 530, 315)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        // つま先ここまで
      }
      break
    case 'leatherSoleWithEva':
      {
        // かかと側ここから
        // 歯a
        ctx.fillStyle = '#44463F'
        ctx.beginPath()
        ctx.moveTo(372, 245) // 左上
        ctx.quadraticCurveTo(370, 253, 377, 258) // 左下
        ctx.quadraticCurveTo(383, 258, 383, 255) // 右下
        ctx.quadraticCurveTo(386, 245, 386, 245) // 右上
        ctx.quadraticCurveTo(372, 245, 372, 245)
        // ctx.quadraticCurveTo()
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.strokeStyle = '#383838'

        ctx.strokeStyle = '#383838'
        ctx.fillStyle = '#bfbfbf'
        // フレーム部分
        ctx.beginPath()
        ctx.moveTo(369, 243) // 左下
        ctx.quadraticCurveTo(357, 232, 357, 232) // 左上
        ctx.quadraticCurveTo(397, 251, 435, 254)
        ctx.quadraticCurveTo(447, 257, 450, 259)
        ctx.quadraticCurveTo(399, 260, 369, 243)
        // ctx.quadraticCurveTo()
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        // かかと側ここまで

        // つま先ここから
        // 歯b
        ctx.fillStyle = '#44463F'
        ctx.beginPath()
        ctx.moveTo(537, 325) // 左上
        ctx.quadraticCurveTo(535, 355, 553, 349)
        ctx.quadraticCurveTo(555, 338, 555, 338)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()

        // 歯c
        ctx.beginPath()
        ctx.moveTo(612, 370) // 左上
        ctx.quadraticCurveTo(608, 383, 626, 382) // 中央左
        ctx.quadraticCurveTo(627, 375, 629, 381) // 中央右
        ctx.quadraticCurveTo(638, 380, 635, 375) // 右上
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.strokeStyle = '#383838'

        // 歯d
        ctx.fillStyle = '#44463F'
        ctx.beginPath()
        ctx.moveTo(714, 381) // 左上
        ctx.quadraticCurveTo(725, 395, 734, 376)
        // ctx.quadraticCurveTo()
        // ctx.quadraticCurveTo()
        // ctx.quadraticCurveTo()
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.strokeStyle = '#383838'
        //// フレーム部分
        ctx.fillStyle = '#bfbfbf'
        ctx.beginPath()
        ctx.moveTo(530, 315)
        ctx.quadraticCurveTo(555, 350, 585, 361)
        ctx.quadraticCurveTo(634, 380, 703, 381)
        ctx.quadraticCurveTo(745, 382, 754, 353) // 右端
        ctx.quadraticCurveTo(740, 382, 699, 376)
        ctx.quadraticCurveTo(580, 373, 530, 315)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        // つま先ここまで
      }
      break
    case 'runningShoesSole':
    case 'artificialTurfSole':
      {
        // かかと側ここから
        ctx.strokeStyle = '#383838'
        ctx.fillStyle = '#eee'
        // フレーム部分
        ctx.beginPath()
        ctx.moveTo(369, 249) // 左下
        ctx.quadraticCurveTo(357, 232, 357, 232) // 左上
        ctx.quadraticCurveTo(397, 254, 435, 253)
        ctx.quadraticCurveTo(457, 263, 457, 263)
        ctx.quadraticCurveTo(399, 264, 369, 249)
        // ctx.quadraticCurveTo()
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        // かかと側ここまで

        //// フレーム部分
        ctx.beginPath()
        ctx.moveTo(530, 315)
        ctx.quadraticCurveTo(555, 350, 585, 364)
        ctx.quadraticCurveTo(634, 383, 703, 385)
        ctx.quadraticCurveTo(745, 386, 754, 353) // 右端
        ctx.quadraticCurveTo(740, 382, 699, 376)
        ctx.quadraticCurveTo(580, 373, 530, 315)
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
      }
      break
  }
} // アウトソール

// アウトソール
const outSolesRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  switch (state.outSole.value) {
    case 'resinSoleEvaWhiteCleats':
    case 'unselected':
    case 'leatherSoleWithEva':
      ctx.fillStyle = '#bfbfbf'
      break

    case 'pointSole':
    case 'runningShoesSole':
    case 'artificialTurfSole':
      ctx.fillStyle = '#eee'
      break
  }

  //// つま先のフレーム部分
  ctx.strokeStyle = '#383838'
  ctx.beginPath()
  ctx.moveTo(249, 513) // 左上
  ctx.quadraticCurveTo(478, 613, 477, 615) // 右下
  ctx.quadraticCurveTo(390, 730, 249, 513)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const meshRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return
  ctx.fillStyle = '#ccc'
  // 内側サイド
  generateMesh(ctx, 1, 465, 478)
  generateMesh(ctx, 2, 465, 490) //
  generateMesh(ctx, 2, 465, 502) //
  generateMesh(ctx, 2, 465, 514) //
  generateMesh(ctx, 2, 469, 524) //
  generateMesh(ctx, 2, 471, 536) //
  generateMesh(ctx, 2, 472, 549) //
  generateMesh(ctx, 2, 475, 560) //
  generateMesh(ctx, 1, 478, 570) //
  generateMesh(ctx, 1, 480, 580) //
  // 外側サイド
  generateMesh(ctx, 1, 258, 523)
  generateMesh(ctx, 2, 264, 529) //
  generateMesh(ctx, 2, 270, 535) //
  generateMesh(ctx, 3, 276, 541) //
  generateMesh(ctx, 3, 280, 549) //
  generateMesh(ctx, 4, 284, 557) //
  generateMesh(ctx, 4, 288, 565) //
  generateMesh(ctx, 5, 292, 573) //
  generateMesh(ctx, 4, 299, 577) //
  generateMesh(ctx, 4, 305, 583) //
  generateMesh(ctx, 3, 313, 587) //
  generateMesh(ctx, 3, 319, 593) //
  generateMesh(ctx, 3, 325, 599) //
  generateMesh(ctx, 2, 331, 605) //
  generateMesh(ctx, 2, 337, 611) //
  generateMesh(ctx, 1, 343, 615) //
  // サイド補強の間
  generateMesh(ctx, 1, 247, 477) //
  generateMesh(ctx, 1, 254, 480) //
  generateMesh(ctx, 1, 261, 484) //
  // atomsデザイン右下
  generateMesh(ctx, 1, 276, 420) //
  generateMesh(ctx, 1, 276, 430) //
  generateMesh(ctx, 1, 276, 440) //
  generateMesh(ctx, 2, 276, 450) //
  generateMesh(ctx, 1, 283, 456) //
  // atomsデザイン左下
  generateMesh(ctx, 2, 249, 434) //
  generateMesh(ctx, 1, 255, 438) //
  // atomsデザイン中央
  generateMesh(ctx, 1, 239, 376) //
  generateMesh(ctx, 2, 237, 388) //
  generateMesh(ctx, 3, 235, 401) //
  // atomsデザイン右上
  generateMesh(ctx, 1, 248, 312) //
  generateMesh(ctx, 1, 248, 322) //
  generateMesh(ctx, 2, 248, 332) //
  generateMesh(ctx, 1, 253, 339) //
  generateMesh(ctx, 1, 258, 346) //

  switch (state.openingPattern.value) {
    case 'quarterCut':
      // atomsデザイン上
      generateMesh(ctx, 2, 210, 206) //
      generateMesh(ctx, 2, 210, 216) //
      generateMesh(ctx, 2, 211, 226) //
      generateMesh(ctx, 2, 212, 236) //
      generateMesh(ctx, 2, 214, 246) //
      generateMesh(ctx, 2, 217, 254) //
      generateMesh(ctx, 1, 227, 257) //
      generateMesh(ctx, 1, 227, 269) //
      generateMesh(ctx, 2, 227, 279) //
      generateMesh(ctx, 2, 227, 289) //
      generateMesh(ctx, 2, 228, 299) //
      generateMesh(ctx, 1, 234, 306) //
      break
    default:
      // atomsデザイン上
      generateMesh(ctx, 1, 214, 236) //
      generateMesh(ctx, 2, 216, 247) //
      generateMesh(ctx, 2, 219, 254) //
      generateMesh(ctx, 1, 227, 257) //
      generateMesh(ctx, 1, 227, 269) //
      generateMesh(ctx, 2, 227, 279) //
      generateMesh(ctx, 2, 227, 289) //
      generateMesh(ctx, 2, 228, 299) //
      generateMesh(ctx, 1, 234, 306) //
      break
  }
}

const onTongueMeshRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return

  ctx.fillStyle = '#ccc'
  const onTongueMeshRightFootDefault = (x = 0, y = 0) => {
    generateMesh(ctx, 5, 218 + x, 161 + y) //
    generateMesh(ctx, 7, 217 + x, 170 + y) //
    generateMesh(ctx, 1, 261 + x, 127 + y) //
    generateMesh(ctx, 11, 217 + x, 180 + y) //
    generateMesh(ctx, 13, 219 + x, 188 + y) //
    generateMesh(ctx, 14, 222 + x, 195 + y) //
    generateMesh(ctx, 15, 224 + x, 203 + y) //
    generateMesh(ctx, 15, 230 + x, 207 + y) //

    generateMesh(ctx, 2, 310 + x, 138 + y) //
    generateMesh(ctx, 2, 310 + x, 148 + y) //
    generateMesh(ctx, 2, 314 + x, 155 + y) //
    generateMesh(ctx, 7, 259 + x, 212 + y) //
    generateMesh(ctx, 11, 260 + x, 222 + y) //
    generateMesh(ctx, 6, 288 + x, 204 + y) //
    generateMesh(ctx, 6, 301 + x, 202 + y) //
    generateMesh(ctx, 3, 314 + x, 200 + y) //
    //ミシンとミシンの間
    generateMesh(ctx, 1, 269 + x, 231 + y) //
    generateMesh(ctx, 1, 276 + x, 225 + y) //
    generateMesh(ctx, 1, 283 + x, 221 + y) //
    generateMesh(ctx, 1, 292 + x, 217 + y) //
    generateMesh(ctx, 1, 301 + x, 214 + y) //
    generateMesh(ctx, 1, 310 + x, 212 + y) //
    generateMesh(ctx, 1, 319 + x, 210 + y) //
    // ミシンの下
    generateMesh(ctx, 3, 273 + x, 240 + y) //
    generateMesh(ctx, 5, 275 + x, 249 + y) //
    generateMesh(ctx, 7, 277 + x, 258 + y) //
    generateMesh(ctx, 9, 279 + x, 267 + y) //
    generateMesh(ctx, 9, 281 + x, 276 + y) //
    generateMesh(ctx, 9, 283 + x, 285 + y) //
    generateMesh(ctx, 9, 285 + x, 294 + y) //
    generateMesh(ctx, 9, 287 + x, 303 + y) //
    generateMesh(ctx, 8, 289 + x, 312 + y) //
    generateMesh(ctx, 9, 291 + x, 321 + y) //
    generateMesh(ctx, 9, 293 + x, 330 + y) //
    generateMesh(ctx, 9, 295 + x, 339 + y) //
    generateMesh(ctx, 9, 297 + x, 348 + y) //
    generateMesh(ctx, 10, 299 + x, 357 + y) //
    generateMesh(ctx, 10, 301 + x, 366 + y) //
    generateMesh(ctx, 10, 303 + x, 375 + y) //
    generateMesh(ctx, 11, 305 + x, 384 + y) //
    generateMesh(ctx, 11, 307 + x, 393 + y) //
    generateMesh(ctx, 11, 309 + x, 402 + y) //
    generateMesh(ctx, 11, 311 + x, 411 + y) //
    generateMesh(ctx, 12, 313 + x, 420 + y) //
    generateMesh(ctx, 12, 315 + x, 429 + y) //
    generateMesh(ctx, 12, 317 + x, 438 + y) //
    generateMesh(ctx, 12, 319 + x, 447 + y) //
    generateMesh(ctx, 12, 321 + x, 456 + y) //
    generateMesh(ctx, 12, 323 + x, 465 + y) //
    generateMesh(ctx, 12, 325 + x, 474 + y) //
    generateMesh(ctx, 12, 327 + x, 483 + y) //
  }
  switch (state.openingPattern.value) {
    case 'quarterCut':
      onTongueMeshRightFootDefault()
      break
    default:
      onTongueMeshRightFootDefault(8, 20)
      break
  }
}

const meshLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return

  ctx.fillStyle = '#ccc'
  switch (state.openingPattern.value) {
    case 'quarterCut':
      generateMesh(ctx, 2, 340, 153)
      generateMesh(ctx, 3, 342, 161) //
      generateMesh(ctx, 4, 345, 168) //
      generateMesh(ctx, 6, 349, 175) //
      generateMesh(ctx, 8, 352, 182) //
      generateMesh(ctx, 8, 358, 187) //
      generateMesh(ctx, 8, 364, 193) //
      generateMesh(ctx, 8, 370, 198) //
      generateMesh(ctx, 7, 376, 203) //
      generateMesh(ctx, 8, 380, 210) //
      generateMesh(ctx, 8, 387, 215) //
      generateMesh(ctx, 8, 393, 220) //
      generateMesh(ctx, 8, 399, 225) //
      generateMesh(ctx, 8, 405, 230) //
      generateMesh(ctx, 8, 411, 235) //
      generateMesh(ctx, 8, 417, 240) //
      generateMesh(ctx, 7, 423, 245) //
      generateMesh(ctx, 7, 429, 250) //
      generateMesh(ctx, 7, 435, 255) //
      generateMesh(ctx, 7, 441, 260) //
      generateMesh(ctx, 2, 477, 236) //
      generateMesh(ctx, 1, 490, 236) //
      generateMesh(ctx, 1, 483, 269) //
      generateMesh(ctx, 2, 490, 274) //
      generateMesh(ctx, 2, 497, 279) //
      generateMesh(ctx, 6, 524, 306) //
      generateMesh(ctx, 6, 533, 309) //
      generateMesh(ctx, 6, 542, 312) //
      generateMesh(ctx, 6, 551, 315) //
      generateMesh(ctx, 6, 560, 318) //
      // サイド補強の間
      generateMesh(ctx, 1, 551, 330) //
      generateMesh(ctx, 1, 560, 329) //
      generateMesh(ctx, 1, 569, 328) //
      generateMesh(ctx, 1, 578, 327) //
      // サイド補強下
      generateMesh(ctx, 1, 586, 353) //
      generateMesh(ctx, 3, 593, 356) //
      generateMesh(ctx, 4, 601, 359) //
      generateMesh(ctx, 5, 609, 362) //
      generateMesh(ctx, 6, 617, 365) //
      generateMesh(ctx, 7, 625, 368) //
      generateMesh(ctx, 7, 633, 371) //
      generateMesh(ctx, 7, 641, 374) //
      generateMesh(ctx, 7, 649, 377) //
      generateMesh(ctx, 7, 657, 380) //
      generateMesh(ctx, 5, 677, 372) //
      generateMesh(ctx, 4, 688, 372) //
      generateMesh(ctx, 5, 688, 382) //
      generateMesh(ctx, 3, 709, 372) //
      break
    default:
      generateMesh(ctx, 1, 347, 171)
      generateMesh(ctx, 1, 353, 177) //
      generateMesh(ctx, 2, 358, 185) //
      generateMesh(ctx, 3, 363, 193) //
      generateMesh(ctx, 4, 368, 201) //
      generateMesh(ctx, 6, 373, 209) //
      generateMesh(ctx, 8, 378, 217) //
      generateMesh(ctx, 8, 384, 223) //
      generateMesh(ctx, 8, 390, 229) //
      generateMesh(ctx, 8, 396, 235) //
      generateMesh(ctx, 8, 402, 241) //
      generateMesh(ctx, 8, 408, 247) //
      generateMesh(ctx, 8, 414, 253) //
      generateMesh(ctx, 3, 459, 222) //
      generateMesh(ctx, 3, 465, 228) //
      generateMesh(ctx, 3, 471, 234) //
      generateMesh(ctx, 3, 477, 240) //
      generateMesh(ctx, 3, 483, 246) //
      // ATOMSマークの中央
      generateMesh(ctx, 1, 490, 273) //
      generateMesh(ctx, 1, 497, 278) //
      // ATOMSマークの右上
      generateMesh(ctx, 1, 547, 270) //
      generateMesh(ctx, 1, 554, 275) //
      generateMesh(ctx, 1, 534, 295) //
      generateMesh(ctx, 5, 537, 302) //
      generateMesh(ctx, 5, 540, 309) //
      generateMesh(ctx, 5, 564, 296) //
      generateMesh(ctx, 5, 570, 301) //
      generateMesh(ctx, 5, 574, 308) //
      // サイド補強の間
      generateMesh(ctx, 1, 550, 329) //
      generateMesh(ctx, 1, 559, 328) //
      generateMesh(ctx, 1, 568, 327) //
      generateMesh(ctx, 1, 577, 326) //
      // サイド補強の下
      generateMesh(ctx, 1, 585, 352) //
      generateMesh(ctx, 3, 591, 355) //
      generateMesh(ctx, 4, 599, 358) //
      generateMesh(ctx, 5, 607, 361) //
      generateMesh(ctx, 6, 615, 364) //
      generateMesh(ctx, 7, 623, 367) //
      generateMesh(ctx, 7, 631, 370) //
      generateMesh(ctx, 7, 639, 373) //
      generateMesh(ctx, 6, 654, 369) //
      generateMesh(ctx, 6, 663, 370) //
      generateMesh(ctx, 6, 672, 371) //
      generateMesh(ctx, 6, 681, 372) //
      generateMesh(ctx, 4, 690, 373) //
      generateMesh(ctx, 3, 699, 374) //
      generateMesh(ctx, 2, 708, 375) //
      break
  }
}

const onTongueMeshLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const { isMesh } = getUpperMaterial(state)
  if (!isMesh) return

  ctx.fillStyle = '#ccc'
  const onTongueMeshLeftFootDefault = (x = 0, y = 0) => {
    //ミシンとミシンの間
    generateMesh(ctx, 11, 352 + x, 113 + y) //
    generateMesh(ctx, 12, 352 + x, 124 + y) //
    generateMesh(ctx, 13, 355 + x, 133 + y) //
    generateMesh(ctx, 13, 362 + x, 138 + y) //
    generateMesh(ctx, 12, 372 + x, 140 + y) //
    generateMesh(ctx, 11, 390 + x, 137 + y) //
    generateMesh(ctx, 4, 438 + x, 111 + y) //
    generateMesh(ctx, 4, 440 + x, 121 + y) //
    generateMesh(ctx, 4, 445 + x, 128 + y) //
    generateMesh(ctx, 5, 452 + x, 142 + y) //
    generateMesh(ctx, 4, 467 + x, 146 + y) //
    generateMesh(ctx, 4, 474 + x, 150 + y) //
    generateMesh(ctx, 4, 481 + x, 154 + y) //
    generateMesh(ctx, 4, 488 + x, 158 + y) //
    generateMesh(ctx, 3, 495 + x, 162 + y) //
    generateMesh(ctx, 3, 502 + x, 166 + y) //
    generateMesh(ctx, 3, 509 + x, 170 + y) //
    generateMesh(ctx, 4, 516 + x, 174 + y) //
    generateMesh(ctx, 5, 508 + x, 188 + y) //
    generateMesh(ctx, 5, 516 + x, 192 + y) //
    generateMesh(ctx, 5, 524 + x, 196 + y) //
    generateMesh(ctx, 5, 532 + x, 200 + y) //
    generateMesh(ctx, 4, 540 + x, 204 + y) //
    generateMesh(ctx, 4, 548 + x, 208 + y) //
    generateMesh(ctx, 4, 556 + x, 212 + y) //
    generateMesh(ctx, 4, 564 + x, 216 + y) //
    generateMesh(ctx, 5, 563 + x, 229 + y) //
    generateMesh(ctx, 3, 580 + x, 224 + y) //
    generateMesh(ctx, 4, 588 + x, 228 + y) //
    generateMesh(ctx, 5, 583 + x, 242 + y) //
    generateMesh(ctx, 5, 590 + x, 245 + y) //
    generateMesh(ctx, 7, 598 + x, 249 + y) //
    generateMesh(ctx, 7, 606 + x, 253 + y) //
    generateMesh(ctx, 7, 614 + x, 257 + y) //
    // generateMesh(ctx, 4, ) //
  }
  switch (state.openingPattern.value) {
    case 'quarterCut':
      onTongueMeshLeftFootDefault()
      break
    default:
      onTongueMeshLeftFootDefault(28, 20)
      break
  }
}

const openingReinforcementLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  if (state.openingPattern.value === 'quarterCut') return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.openingReinforcement.color
  ctx.beginPath()
  ctx.moveTo(325, 120) // 左上
  ctx.quadraticCurveTo(327, 154, 346, 166) // 左下
  ctx.quadraticCurveTo(377, 190, 426, 170) // 右下
  ctx.quadraticCurveTo(414, 154, 414, 154) // 右上
  ctx.quadraticCurveTo(370, 172, 345, 142) // 左上_右
  ctx.quadraticCurveTo(325, 120, 325, 120)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(332, 147)
  ctx.quadraticCurveTo(360, 189, 420, 168)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0
}

const openingReinforcementRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  if (state.openingPattern.value === 'quarterCut') return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.openingReinforcement.color
  ctx.beginPath()
  ctx.moveTo(207, 198) // 左上
  ctx.quadraticCurveTo(205, 227, 229, 245) // 左下
  ctx.quadraticCurveTo(233, 218, 233, 218) // 右下
  ctx.quadraticCurveTo(221, 195, 221, 195) // 右上
  ctx.quadraticCurveTo(212, 189, 207, 198) // 左上_
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(209, 201)
  ctx.quadraticCurveTo(207, 224, 229, 242)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0
}

const toeGuardRightFoot = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  if (state.toeGuard.value !== 'rightToeGuard') return

  const pitcherToeGuardRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.toeGuardColor.color
    ctx.moveTo(358, 291) // 右上_左
    ctx.quadraticCurveTo(404, 409, 404, 409) // ベロ右下_1
    ctx.quadraticCurveTo(404, 427, 383, 434) // ベロ右下_2
    ctx.quadraticCurveTo(318, 490, 340, 618) // 左下_
    ctx.quadraticCurveTo(368, 656, 426, 653) // つま先＿先端
    ctx.quadraticCurveTo(480, 629, 483, 588) // つま先＿右下
    ctx.quadraticCurveTo(492, 526, 465, 455)
    ctx.quadraticCurveTo(400, 312, 403, 315) // 右上_右
    ctx.quadraticCurveTo(383, 283, 358, 291)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    // ctx.fillStyle = '#A7A897'
    ctx.fillStyle = darkenColor(state.toeGuardColor.color, 0.3)
    ctx.moveTo(345, 622) // 左下
    ctx.quadraticCurveTo(371, 656, 426, 653) // つま先＿先端
    ctx.quadraticCurveTo(480, 629, 481, 584) // つま先＿右下
    ctx.quadraticCurveTo(492, 526, 462, 455)
    ctx.quadraticCurveTo(375, 520, 345, 622) // 左下_
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.lineWidth = 1.2
    ctx.strokeStyle = state.stitch.color
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.moveTo(342, 620) // 左下
    ctx.quadraticCurveTo(329, 500, 370, 459)
    ctx.quadraticCurveTo(385, 442, 416, 437)
    ctx.quadraticCurveTo(430, 427, 428, 410)
    ctx.quadraticCurveTo(418, 375, 386, 298)
    ctx.moveTo(345, 620) // 左下
    ctx.quadraticCurveTo(332, 500, 373, 459)
    ctx.quadraticCurveTo(391, 446, 419, 440)
    ctx.quadraticCurveTo(433, 427, 431, 410)
    ctx.quadraticCurveTo(421, 375, 389, 298)

    ctx.moveTo(397, 377) // 左下
    ctx.quadraticCurveTo(364, 294, 364, 294)
    ctx.quadraticCurveTo(388, 298, 388, 303)
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 1.0
  }
  const fielderToeGuardRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    const fillColor = darkenColor(state.toeGuardColor.color, 0.3)
    ctx.fillStyle = fillColor
    ctx.moveTo(345, 622) // 左下
    ctx.quadraticCurveTo(371, 656, 426, 653) // つま先＿先端
    ctx.quadraticCurveTo(480, 629, 483, 590) // つま先＿右下
    ctx.quadraticCurveTo(492, 526, 468, 470)
    ctx.quadraticCurveTo(375, 520, 345, 622) // 左下_
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.lineWidth = 1.2
    ctx.strokeStyle = state.stitch.color
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.moveTo(349, 625) // 左下
    ctx.quadraticCurveTo(378, 523, 469, 476)
    ctx.moveTo(353, 625) // 左下
    ctx.quadraticCurveTo(382, 526, 472, 479)
    // ctx.quadraticCurveTo()
    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 1.0
  }

  const metalEdge = (ctx: CanvasRenderingContext2D): void => {
    ctx.beginPath()
    ctx.fillStyle = '#383838'
    ctx.strokeStyle = '#383838'
    ctx.moveTo(410, 650) // 左下_上
    ctx.quadraticCurveTo(405, 654, 411, 657) // 左下_下
    ctx.quadraticCurveTo(485, 645, 486, 568) // 右上
    ctx.quadraticCurveTo(480, 571, 480, 571)
    ctx.quadraticCurveTo(475, 640, 410, 650)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const toeGuardKind = state.toeGuardKind.value
  if (['forPitcher', 'forPitcherWithMetalReinforcement'].includes(toeGuardKind)) {
    pitcherToeGuardRightFoot(ctx, state)
    if (state.vampStrapType.value === 'laceType') {
      laceHole(ctx, state, 354, 243)
      laceHole(ctx, state, 365, 275)
      laceHole(ctx, state, 378, 310)
      laceHole(ctx, state, 391, 342)
      laceHole(ctx, state, 403, 373)
      // 紐穴
      laceHole(ctx, state, 302, 448)
      laceHole(ctx, state, 418, 409)

      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.vampStrap.color
      leftDownRightUp(ctx, -45, -131)
      leftDownRightUp(ctx, -36, -98)
      leftDownRightUp(ctx, -24, -64)
      leftDownRightUp(ctx, -14, -32)
      leftDownRightUp(ctx, -2)

      // 一番下の紐
      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.vampStrap.color
      ctx.beginPath()
      ctx.moveTo(305, 452) // 左下
      ctx.quadraticCurveTo(295, 448, 303, 442) // 左上
      ctx.quadraticCurveTo(360, 414, 416, 405) // 右上
      ctx.quadraticCurveTo(424, 407, 419, 414) // 右下
      ctx.quadraticCurveTo(361, 428, 305, 452)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    }
  }

  if (state.vampStrapType.value === 'beltTypeSameDirection') {
    // 一番上
    magicBeltBase(ctx, state, -30, -100)
    turnAroundMetalFittings(ctx, state, -30, -100)
    const belt1Color = state.vampStrapBelt1.color
    magicBeltTurnAround(ctx, belt1Color, state, -30, -100)

    // 中間
    magicBeltBase(ctx, state, -15, -50)
    turnAroundMetalFittings(ctx, state, -15, -50)
    const belt2Color = state.vampStrapBelt2.color
    magicBeltTurnAround(ctx, belt2Color, state, -15, -50)

    // 一番下
    magicBeltBase(ctx, state)
    turnAroundMetalFittings(ctx, state)
    const belt3Color = state.vampStrapBelt3.color
    magicBeltTurnAround(ctx, belt3Color, state)
  }
  if (state.vampStrapType.value === 'beltTypeReverseDirection') {
    // 一番上
    magicBeltBase(ctx, state, -30, -100)
    turnAroundMetalFittings(ctx, state, -30, -100)
    const belt1Color = state.vampStrapBelt1.color
    magicBeltTurnAround(ctx, belt1Color, state, -30, -100)

    // 中間
    magicBeltBase(ctx, state, 3, -55)
    turnAroundMetalFittings(ctx, state, -95, -25)
    const belt2Color = state.vampStrapBelt2.color
    magicBeltTurnAroundReverse(ctx, belt2Color, state, 4, -5)

    // 一番下
    magicBeltBase(ctx, state)
    turnAroundMetalFittings(ctx, state)
    const belt3Color = state.vampStrapBelt3.color
    magicBeltTurnAround(ctx, belt3Color, state)
  }

  if (['forFielder', 'forFielderWithMetalReinforcement'].includes(toeGuardKind)) {
    fielderToeGuardRightFoot(ctx, state)
  }

  if (['forFielderWithMetalReinforcement', 'forPitcherWithMetalReinforcement'].includes(toeGuardKind)) {
    metalEdge(ctx)
  }
}

const toeGuardLeftFoot = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  if (state.toeGuard.value !== 'leftToeGuard') return
  const pitcherToeGuardLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.toeGuardColor.color
    ctx.moveTo(513, 195) // マジックベルト横
    ctx.quadraticCurveTo(562, 238, 608, 259) // つま先補強の入口
    ctx.quadraticCurveTo(618, 262, 627, 253)
    ctx.quadraticCurveTo(653, 243, 704, 256)
    ctx.quadraticCurveTo(745, 280, 752, 299)
    ctx.quadraticCurveTo(767, 319, 756, 349) // つま先
    ctx.quadraticCurveTo(745, 382, 694, 376)
    ctx.quadraticCurveTo(575, 370, 527, 313)
    ctx.quadraticCurveTo(511, 298, 511, 298)
    ctx.quadraticCurveTo(497, 235, 497, 220)
    ctx.quadraticCurveTo(500, 210, 513, 195)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.lineWidth = 1.2
    ctx.strokeStyle = state.stitch.color
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.moveTo(506, 211)
    ctx.quadraticCurveTo(513, 202, 513, 202)
    ctx.quadraticCurveTo(573, 245, 573, 245)

    ctx.moveTo(514, 294)
    ctx.quadraticCurveTo(504, 259, 502, 227)
    ctx.quadraticCurveTo(540, 262, 586, 282)
    ctx.quadraticCurveTo(624, 299, 639, 274)
    ctx.quadraticCurveTo(652, 245, 710, 259)
    ctx.moveTo(518, 296)
    ctx.quadraticCurveTo(508, 261, 506, 236)
    ctx.quadraticCurveTo(542, 267, 590, 288)
    ctx.quadraticCurveTo(626, 301, 642, 276)
    ctx.quadraticCurveTo(654, 247, 712, 263)

    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 1.0

    // 先端の固めている部分
    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = darkenColor(state.toeGuardColor.color, 0.3)
    ctx.moveTo(535, 321)
    ctx.quadraticCurveTo(586, 330, 682, 287)
    ctx.quadraticCurveTo(734, 272, 746, 289)
    ctx.quadraticCurveTo(767, 319, 756, 349) // つま先
    ctx.quadraticCurveTo(745, 382, 694, 376)
    ctx.quadraticCurveTo(575, 370, 535, 321)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    const magicBeltTurnAroundReverse = (ctx: CanvasRenderingContext2D, state: ShoesState, x = 0, y = 0) => {
      ctx.lineWidth = 1.0
      ctx.fillStyle = state.vampStrap.color
      ctx.strokeStyle = '#383838'
      ctx.beginPath()
      ctx.moveTo(529, 227) // 左下
      ctx.quadraticCurveTo(513, 228, 494, 215) // 左上
      ctx.quadraticCurveTo(523, 198, 547, 161) // 右上
      ctx.quadraticCurveTo(557, 160, 564, 175) // 右下
      ctx.quadraticCurveTo(542, 219, 529, 227)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()

      // stitch
      ctx.lineWidth = 1.2
      ctx.strokeStyle = state.stitch.color
      ctx.setLineDash([3, 3])
      ctx.beginPath()
      ctx.moveTo(548, 165)
      ctx.quadraticCurveTo(524, 201, 503, 214)
      ctx.quadraticCurveTo(527, 228, 537, 212)
      ctx.quadraticCurveTo(546, 201, 560, 175)
      ctx.moveTo(521, 200)
      ctx.quadraticCurveTo(542, 204, 542, 204)
      ctx.moveTo(528, 191)
      ctx.quadraticCurveTo(550, 194, 550, 194)
      ctx.stroke()
      ctx.setLineDash([])
      ctx.closePath()
    }

    if (state.vampStrapType.value === 'beltTypeReverseDirection') {
      magicBeltTurnAroundReverse(ctx, state)
    }
  }
  const fielderToeGuardLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
    ctx.beginPath()
    ctx.strokeStyle = '#383838'
    ctx.fillStyle = darkenColor(state.toeGuardColor.color, 0.3)
    ctx.moveTo(594, 360) // 左上_左
    ctx.quadraticCurveTo(605, 335, 650, 305)
    ctx.quadraticCurveTo(692, 285, 742, 283)
    ctx.quadraticCurveTo(770, 319, 756, 349) // つま先
    ctx.quadraticCurveTo(745, 382, 694, 379)
    ctx.quadraticCurveTo(644, 378, 594, 360)
    // ctx.quadraticCurveTo()
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.lineWidth = 1.2
    ctx.strokeStyle = state.stitch.color
    ctx.beginPath()
    ctx.setLineDash([3, 3])
    ctx.moveTo(598, 361) // 左下
    ctx.quadraticCurveTo(645, 290, 743, 287)

    ctx.moveTo(602, 363) // 左下
    ctx.quadraticCurveTo(648, 293, 747, 292)

    ctx.stroke()
    ctx.setLineDash([])
    ctx.closePath()
    ctx.lineWidth = 1.0
  }

  const metalEdge = (ctx: CanvasRenderingContext2D): void => {
    ctx.beginPath()
    ctx.fillStyle = '#383838'
    ctx.strokeStyle = '#383838'
    ctx.moveTo(647, 372) // 左下_上
    ctx.quadraticCurveTo(639, 374, 645, 379)
    ctx.quadraticCurveTo(738, 392, 750, 364)
    ctx.quadraticCurveTo(721, 383, 647, 372)
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const toeGuardKind = state.toeGuardKind.value
  if (['forPitcher', 'forPitcherWithMetalReinforcement'].includes(toeGuardKind)) {
    pitcherToeGuardLeftFoot(ctx, state)
    // レース
    if (state.vampStrapType.value === 'laceType') {
      laceHole(ctx, state, 457, 168)
      laceHole(ctx, state, 482, 190)
      laceHole(ctx, state, 509, 215)
      laceHole(ctx, state, 539, 239)
      laceHole(ctx, state, 564, 258)
      laceHole(ctx, state, 595, 272)

      laceOfLeftFoot1(ctx, state)
      laceOfLeftFoot1(ctx, state, -25, -15)
      laceOfLeftFoot1(ctx, state, -50, -32)
      laceOfLeftFoot1(ctx, state, -80, -58)
      laceOfLeftFoot1(ctx, state, -100, -77)
      laceOfLeftFoot2(ctx, state)
      laceOfLeftFoot2(ctx, state, -25, -18)
      laceOfLeftFoot2(ctx, state, -54, -38)
      laceOfLeftFoot2(ctx, state, -80, -60)
      laceOfLeftFoot2(ctx, state, -105, -85)

      // 一番下の紐
      ctx.strokeStyle = '#383838'
      ctx.fillStyle = state.vampStrap.color
      ctx.beginPath()
      ctx.moveTo(600, 274) // 左下
      ctx.quadraticCurveTo(593, 277, 592, 271) // 左上
      ctx.quadraticCurveTo(625, 210, 625, 210) // 右上
      ctx.quadraticCurveTo(629, 210, 632, 216) // 右下
      ctx.quadraticCurveTo(618, 248, 600, 274)
      ctx.fill()
      ctx.stroke()
      ctx.closePath()
    }
  }

  if (['forFielder', 'forFielderWithMetalReinforcement'].includes(toeGuardKind)) {
    fielderToeGuardLeftFoot(ctx, state)
  }

  if (['forFielderWithMetalReinforcement', 'forPitcherWithMetalReinforcement'].includes(toeGuardKind)) {
    metalEdge(ctx)
  }
}

const foldingTongueFrontLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  if (state.tongue.value !== 'foldingTongue') return // 折りベロじゃない
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.tongueFront.color
  ctx.beginPath()
  ctx.moveTo(438, 141) // 左上
  ctx.quadraticCurveTo(433, 153, 441, 170)
  ctx.quadraticCurveTo(462, 196, 462, 196)
  ctx.quadraticCurveTo(475, 205, 493, 201) // 左下
  ctx.quadraticCurveTo(535, 159, 535, 159) // 右下_1
  ctx.quadraticCurveTo(545, 151, 534, 137) // 右下_2
  ctx.quadraticCurveTo(515, 100, 484, 93) // 右上
  ctx.quadraticCurveTo(456, 112, 438, 141)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(440, 140)
  ctx.quadraticCurveTo(438, 162, 446, 168)
  ctx.quadraticCurveTo(464, 193, 464, 193)
  ctx.quadraticCurveTo(474, 199, 491, 196)
  ctx.quadraticCurveTo(513, 168, 535, 156) // 右下_1
  ctx.quadraticCurveTo(539, 146, 523, 130)
  ctx.quadraticCurveTo(518, 115, 486, 92)
  ctx.moveTo(443, 137)
  ctx.quadraticCurveTo(441, 159, 449, 164)
  ctx.quadraticCurveTo(467, 190, 467, 190)
  ctx.quadraticCurveTo(477, 196, 493, 193)
  ctx.quadraticCurveTo(510, 166, 532, 153) // 右下_1
  ctx.quadraticCurveTo(533, 143, 517, 127)
  ctx.quadraticCurveTo(511, 113, 481, 95)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0

  atomsMarkLeftFoot(ctx, state, 60, 55) // ATOMSマーク
}
const foldingTongueFrontRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  if (state.tongue.value !== 'foldingTongue') return // 折りベロじゃない
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.tongueFront.color
  ctx.beginPath()
  ctx.moveTo(246, 210) // 左上
  ctx.quadraticCurveTo(220, 276, 249, 315) // 左下
  ctx.quadraticCurveTo(255, 328, 275, 323) // 左下_2
  ctx.quadraticCurveTo(315, 302, 381, 300) // 右下_1
  ctx.quadraticCurveTo(389, 273, 383, 259) // 右下_2
  ctx.quadraticCurveTo(378, 230, 360, 209) // 右上
  ctx.quadraticCurveTo(347, 193, 324, 198)
  ctx.quadraticCurveTo(291, 189, 246, 210)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = state.stitch.color
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(253, 208)
  ctx.quadraticCurveTo(222, 272, 253, 313)
  ctx.quadraticCurveTo(259, 321, 275, 316)
  ctx.quadraticCurveTo(304, 298, 376, 295)
  ctx.quadraticCurveTo(382, 273, 378, 262) // 右下_2
  ctx.quadraticCurveTo(375, 229, 354, 209)
  ctx.quadraticCurveTo(349, 199, 334, 200)
  ctx.moveTo(256, 206)
  ctx.quadraticCurveTo(230, 282, 258, 310)
  ctx.quadraticCurveTo(257, 317, 279, 308)
  ctx.quadraticCurveTo(305, 290, 370, 290)
  ctx.quadraticCurveTo(374, 270, 373, 260) // 右下_2
  ctx.quadraticCurveTo(372, 239, 349, 209)
  ctx.quadraticCurveTo(346, 202, 331, 203)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.lineWidth = 1.0

  atomsMarkRightFoot(ctx, state, 38, 85) // ATOMSマーク
}

const foldingRootTongueRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#383838'
  const coordinates = { x0: 200, y0: 140, x1: 0, y1: 350 }
  const gradient = generateLiningsGradient(ctx, state.tongueFront.color, coordinates)
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(260, 298) // 左上
  ctx.lineTo(317, 464) // 左下
  ctx.lineTo(425, 433) // 右下
  ctx.lineTo(374, 273) // 右上
  ctx.lineTo(260, 298) // 左上
  ctx.fill()
  ctx.stroke()
}
const foldingRootTongueLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.strokeStyle = '#383838'
  const coordinates = { x0: 0, y0: 300, x1: 10, y1: 140 }
  const gradient = generateLiningsGradient(ctx, state.tongueFront.color, coordinates)
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(470, 179) // 左上
  ctx.lineTo(626, 279)
  ctx.lineTo(649, 229)
  ctx.lineTo(511, 141)
  ctx.lineTo(470, 179)
  ctx.fill()
  ctx.stroke()
}

const tongueRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const openingPattern = state.openingPattern.value
  const isQuarterCut = openingPattern === 'quarterCut'
  const RIGHT_FOOT_TONGUE_X = isQuarterCut ? 0 : 8
  const RIGHT_FOOT_TONGUE_Y = isQuarterCut ? 0 : 20
  if (state.tongue.value === 'foldingTongue') {
    foldingRootTongueRightFoot(ctx, state) // ベロ根元
  }
  if (state.tongue.value !== 'foldingTongue') {
    tongueFrontRightFoot(ctx, state, RIGHT_FOOT_TONGUE_X, RIGHT_FOOT_TONGUE_Y) // ベロ表
    onTongueMeshRightFoot(ctx, state) // ベロメッシュ
    atomsMarkRightFoot(ctx, state, RIGHT_FOOT_TONGUE_X, RIGHT_FOOT_TONGUE_Y) // atomsマーク
  }
}
const tongueLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  const openingPattern = state.openingPattern.value
  const isQuarterCut = openingPattern === 'quarterCut'
  const LEFT_FOOT_TONGUE_X = isQuarterCut ? 0 : 27
  const LEFT_FOOT_TONGUE_Y = isQuarterCut ? 0 : 20
  if (state.tongue.value === 'foldingTongue') {
    foldingRootTongueLeftFoot(ctx, state) // ベロ根元
  }

  if (state.tongue.value !== 'foldingTongue') {
    tongueFrontLeftFoot(ctx, state, LEFT_FOOT_TONGUE_X, LEFT_FOOT_TONGUE_Y) // ベロ表
    onTongueMeshLeftFoot(ctx, state) // ベロメッシュ
    atomsMarkLeftFoot(ctx, state, LEFT_FOOT_TONGUE_X, LEFT_FOOT_TONGUE_Y) // atomsマーク
  }
}

const middleCutRightFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  if (!['mountainMiddleCut', 'horizontalMiddleCut'].includes(state.openingPattern.value)) return
  // ctx.strokeStyle = '#383838'

  if (state.openingPattern.value === 'mountainMiddleCut') {
    // ミドルカット裏地
    ctx.fillStyle = state.tongueLinings.color
    ctx.beginPath()
    ctx.moveTo(227, 221) // 左下＿左
    ctx.quadraticCurveTo(178, 198, 222, 148) // 左上途中
    ctx.quadraticCurveTo(225, 146, 223, 138) // 左上
    ctx.quadraticCurveTo(237, 110, 281, 130) // 右上
    ctx.quadraticCurveTo(357, 137, 347, 195)
    ctx.quadraticCurveTo(307, 244, 227, 221)
    ctx.fill()
    ctx.stroke()

    // 影
    const coordinates = { x0: 0, y0: 500, x1: 10, y1: 40 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient
    ctx.beginPath()
    ctx.moveTo(243, 207) // 左下＿左
    ctx.quadraticCurveTo(198, 184, 230, 156)
    ctx.quadraticCurveTo(239, 126, 275, 137)
    ctx.quadraticCurveTo(337, 142, 322, 183)
    ctx.quadraticCurveTo(298, 218, 243, 207)
    ctx.fill()
    ctx.closePath()

    // ミドルカット外側＿左
    ctx.fillStyle = state.middleCutOpening.color
    ctx.beginPath()
    ctx.moveTo(227, 221) // 左下＿左
    ctx.quadraticCurveTo(238, 213, 238, 213)
    ctx.quadraticCurveTo(212, 205, 202, 182)
    ctx.quadraticCurveTo(197, 212, 227, 221)
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    // ミドルカット外側＿右
    ctx.beginPath()
    ctx.fillStyle = state.middleCutOpening.color
    ctx.moveTo(333, 184) // 左下＿左
    ctx.quadraticCurveTo(346, 195, 347, 195) // 右下
    ctx.quadraticCurveTo(351, 166, 337, 151) // 上
    ctx.quadraticCurveTo(344, 184, 333, 184)
    ctx.fill()
    ctx.closePath()
  }

  if (state.openingPattern.value === 'horizontalMiddleCut') {
    // ミドルカット裏地
    ctx.fillStyle = state.tongueLinings.color
    ctx.strokeStyle = '#383838'
    ctx.beginPath()
    ctx.moveTo(227, 221) // 左下＿左
    ctx.quadraticCurveTo(195, 198, 222, 148) // 左上途中
    ctx.quadraticCurveTo(225, 146, 223, 138) // 左上
    ctx.quadraticCurveTo(237, 110, 281, 130) // 右上
    ctx.quadraticCurveTo(337, 137, 347, 195)
    ctx.quadraticCurveTo(307, 244, 227, 221)
    ctx.fill()
    ctx.stroke()

    // // 影
    const coordinates = { x0: 0, y0: 500, x1: 10, y1: 40 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient
    ctx.beginPath()
    ctx.moveTo(243, 207) // 左下＿左
    ctx.quadraticCurveTo(198, 184, 230, 156)
    ctx.quadraticCurveTo(239, 126, 275, 137)
    ctx.quadraticCurveTo(337, 142, 322, 183)
    ctx.quadraticCurveTo(298, 218, 243, 207)
    ctx.fill()
    ctx.closePath()

    // ミドルカット外側＿左
    ctx.fillStyle = state.middleCutOpening.color
    ctx.beginPath()
    ctx.moveTo(227, 221) // 左下＿左
    ctx.quadraticCurveTo(238, 213, 238, 213)
    ctx.quadraticCurveTo(210, 205, 210, 182)
    ctx.quadraticCurveTo(197, 212, 227, 221)
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    // ミドルカット外側＿右
    ctx.beginPath()
    ctx.fillStyle = state.middleCutOpening.color
    ctx.moveTo(333, 184) // 左下＿左
    ctx.quadraticCurveTo(346, 195, 347, 195) // 右下
    ctx.quadraticCurveTo(351, 166, 327, 151) // 上
    ctx.quadraticCurveTo(344, 184, 333, 184)
    ctx.fill()
    ctx.closePath()
  }
}

// ctx.beginPath()
// ctx.strokeStyle = 'red'
// ctx.fillStyle = state.tongueLinings.color
// ctx.moveTo(227, 221) // 左下＿左
// ctx.quadraticCurveTo() //
// ctx.stroke()
// // ctx.fill()
// ctx.closePath()

const middleCutLeftFoot = (ctx: CanvasRenderingContext2D, state: ShoesState): void => {
  ctx.fillStyle = state.middleCutOpening.color
  ctx.strokeStyle = '#383838'
  const openingPattern = state.openingPattern.value
  if (!['mountainMiddleCut', 'horizontalMiddleCut'].includes(openingPattern)) return

  if (openingPattern === 'horizontalMiddleCut') {
    // 裏地
    ctx.fillStyle = state.tongueLinings.color
    ctx.beginPath()
    ctx.moveTo(435, 142) // 内側＿右下
    ctx.quadraticCurveTo(467, 136, 490, 96) // 外側_右下
    ctx.quadraticCurveTo(474, 78, 446, 75)
    ctx.quadraticCurveTo(426, 68, 357, 69) // かかととの接地
    ctx.quadraticCurveTo(329, 65, 332, 91) // かかととの接地2
    ctx.quadraticCurveTo(350, 154, 435, 142) //
    // ctx.quadraticCurveTo() //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    // 影
    const coordinates = { x0: 0, y0: 200, x1: 10, y1: 40 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient
    ctx.strokeStyle = '#383838'
    ctx.beginPath()
    ctx.moveTo(352, 92) // 左下＿左
    ctx.quadraticCurveTo(386, 80, 440, 95) //
    ctx.quadraticCurveTo(482, 106, 482, 106) // 右下＿ベロ接合
    ctx.quadraticCurveTo(437, 143, 437, 143) //
    ctx.quadraticCurveTo(337, 108, 352, 92) //
    ctx.fill()
    ctx.closePath()

    tongueLeftFoot(ctx, state) // ベロ立ち

    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.tongueLinings.color
    ctx.beginPath()
    // 内側の剥き出している裏地
    ctx.moveTo(341, 84) // 左下＿左
    ctx.quadraticCurveTo(433, 133, 437, 141) //
    ctx.quadraticCurveTo(354, 128, 333, 99) //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.middleCutOpening.color

    // 外側
    ctx.beginPath()
    ctx.moveTo(435, 142) // 右下
    ctx.quadraticCurveTo(390, 173, 357, 153) //
    ctx.quadraticCurveTo(322, 124, 333, 91) // かかと頂点
    ctx.quadraticCurveTo(435, 152, 435, 142) //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()
  }

  if (openingPattern === 'mountainMiddleCut') {
    // 裏地
    ctx.fillStyle = state.tongueLinings.color
    ctx.beginPath()
    ctx.moveTo(435, 142) // 内側＿右下
    ctx.quadraticCurveTo(467, 136, 490, 96) // 外側_右下
    ctx.quadraticCurveTo(474, 70, 446, 61)
    ctx.quadraticCurveTo(426, 68, 357, 69) // かかととの接地
    ctx.quadraticCurveTo(329, 65, 332, 91) // かかととの接地2
    ctx.quadraticCurveTo(350, 154, 435, 142) //
    // ctx.quadraticCurveTo() //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    // 影
    const coordinates = { x0: 0, y0: 200, x1: 10, y1: 40 }
    const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
    ctx.fillStyle = gradient
    ctx.strokeStyle = '#383838'
    ctx.beginPath()
    ctx.moveTo(340, 82) // 左下＿左
    ctx.quadraticCurveTo(406, 96, 440, 80) //
    ctx.quadraticCurveTo(450, 80, 450, 80) //
    ctx.quadraticCurveTo(482, 106, 482, 106) // 右下＿ベロ接合
    ctx.quadraticCurveTo(437, 143, 437, 143) //
    ctx.quadraticCurveTo(337, 108, 340, 82) //
    // ctx.quadraticCurveTo() //
    // ctx.stroke()
    ctx.fill()
    ctx.closePath()

    tongueLeftFoot(ctx, state) // ベロ立ち

    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.tongueLinings.color
    ctx.beginPath()
    // 内側の剥き出している裏地
    ctx.moveTo(341, 84) // 左下＿左
    ctx.quadraticCurveTo(356, 102, 381, 108) //
    ctx.quadraticCurveTo(433, 123, 437, 141) //
    ctx.quadraticCurveTo(354, 128, 333, 99) //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()

    ctx.strokeStyle = '#383838'
    ctx.fillStyle = state.middleCutOpening.color
    // 外側
    ctx.beginPath()
    ctx.moveTo(435, 142) // 右下
    ctx.quadraticCurveTo(390, 173, 357, 153) //
    ctx.quadraticCurveTo(322, 124, 333, 91) // かかと頂点
    ctx.quadraticCurveTo(349, 114, 385, 121) //
    ctx.quadraticCurveTo(425, 129, 435, 142) //
    ctx.stroke()
    ctx.fill()
    ctx.closePath()
  }
}

export const drawAtomsShoesFrontSurface = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.lineWidth = 1.0
  canvasResetter(ctx) // リセット

  openingLiningLeftFoot(ctx, state) // ベロ裏
  tongueLeftFoot(ctx, state) // ベロ立ち
  mainUnitLeftFoot(ctx, state) // 本体
  openingReinforcementLeftFoot(ctx, state) // ベロ補強
  meshLeftFoot(ctx, state) // メッシュ
  healDecorationLeftFoot(ctx, state) // かかと飾り
  sideReinforcementLeftFoot(ctx, state) // 横側補強
  atomsDesignLeftFoot(ctx, state) // atomsデザイン
  middleCutLeftFoot(ctx, state) // ミドルカット
  vampStrapReinforcementLeftFoot(ctx, state) // 紐・ベルト補強
  toeReinforcementLeftFoot(ctx, state) // つま先補強
  healReinforcementLeftFoot(ctx, state) // かかと補強
  outSolesLeftFoot(ctx, state) // アウトソール
  toeGuardLeftFoot(ctx, state) // つま先ガード
  foldingTongueFrontLeftFoot(ctx, state) // ベロ前面

  outSolesRightFoot(ctx, state) // アウトソール
  mainUnitRightFoot(ctx, state) // 本体
  openingReinforcementRightFoot(ctx, state) // ベロ補強
  openingLiningRightFoot(ctx, state) // ベロ裏
  healDecorationRightFoot(ctx, state) // かかと飾り
  middleCutRightFoot(ctx, state) // ミドルカット
  tongueRightFoot(ctx, state) // ベロ立ち
  healReinforcementRightFoot(ctx, state) // かかと補強
  sideReinforcementRightFoot(ctx, state) // 横側補強
  atomsDesignRightFoot(ctx, state) // atomsデザイン
  vampStrapReinforcementRightFoot(ctx, state) // 紐・ベルト補強
  toeReinforcementRightFoot(ctx, state) // つま先補強
  meshRightFoot(ctx, state) // メッシュ
  toeGuardRightFoot(ctx, state) // つま先ガード
  foldingTongueFrontRightFoot(ctx, state) // ベロ前面
}
